var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _rect, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataScienceHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 565,
    height: 485,
    viewBox: "0 0 565 485",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.314 352.505L94.5738 341.113C89.1151 337.962 89.1151 332.823 94.5738 329.672L103.31 324.63C105.065 323.612 105.065 321.964 103.31 320.946L79.8848 307.42",
    stroke: "#C0162E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2461 305.481L106.671 319.007C110.287 321.091 110.287 324.485 106.671 326.569L97.9351 331.611C94.3186 333.696 94.3186 337.089 97.9351 339.174L117.676 350.566",
    stroke: "#C0162E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.621 273.262H106.702L104.123 274.746L101.554 273.262H77.6245L75.0454 274.746L72.476 273.262H48.5469L63.0905 281.649V320.926L48.5469 329.323H72.476L75.0454 327.84L77.6245 329.323H101.554L104.123 327.84L106.702 329.323H130.621L179.178 301.293L130.621 273.262Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 329.323L0 301.293V287.476L48.5465 315.507V329.323Z",
    fill: "#292929"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1032 301.293L48.5469 329.323V315.507L97.1032 287.476V301.293Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 315.507L0 287.476L48.5465 259.446L97.1028 287.476L48.5465 315.507Z",
    fill: "#313131"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9492 317.165L55.9465 316.011V320.277L53.9492 321.431V317.165Z",
    fill: "#59595B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5848 317.824V320.122L17.2207 305.481V303.174L42.5848 317.824Z",
    fill: "url(#paint1_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1849 302V304.308L12.1211 302.543V300.236L15.1849 302Z",
    fill: "url(#paint2_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0488 314.799L60.0461 313.645V317.911L58.0488 319.065V314.799Z",
    fill: "#59595B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 312.433L64.1497 311.279V315.545L62.1523 316.689V312.433Z",
    fill: "#F7F7FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69336 297.094C4.69336 296.164 5.34298 295.786 6.15743 296.251C6.96217 296.716 7.62149 297.851 7.62149 298.782C7.62149 299.712 6.97187 300.09 6.15743 299.625C5.35268 299.16 4.69336 298.025 4.69336 297.094Z",
    fill: "#59595B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 312.54L0 284.5V270.693L48.5465 298.723V312.54Z",
    fill: "#292929"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1032 284.5L48.5469 312.54V298.723L97.1032 270.693V284.5Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 298.723L0 270.693L48.5465 242.662L97.1028 270.693L48.5465 298.723Z",
    fill: "#313131"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9492 300.381L55.9465 299.227V303.493L53.9492 304.647V300.381Z",
    fill: "#C0162E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5848 301.031V303.338L17.2207 288.698V286.39L42.5848 301.031Z",
    fill: "url(#paint3_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1849 285.217V287.515L12.1211 285.75V283.443L15.1849 285.217Z",
    fill: "url(#paint4_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0488 298.015L60.0461 296.862V301.128L58.0488 302.281V298.015Z",
    fill: "#59595B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 295.64L64.1497 294.486V298.752L62.1523 299.906V295.64Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69336 280.311C4.69336 279.38 5.34298 279.002 6.15743 279.468C6.96217 279.933 7.62149 281.067 7.62149 281.998C7.62149 282.929 6.97187 283.307 6.15743 282.842C5.35268 282.376 4.69336 281.242 4.69336 280.311Z",
    fill: "url(#paint5_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 295.747L0 267.716V253.909L48.5465 281.94V295.747Z",
    fill: "#292929"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1032 267.716L48.5469 295.747V281.94L97.1032 253.909V267.716Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 281.94L0 253.909L48.5465 225.869L97.1028 253.909L48.5465 281.94Z",
    fill: "#313131"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9492 283.598L55.9465 282.444V286.71L53.9492 287.864V283.598Z",
    fill: "#59595B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5848 284.247V286.555L17.2207 271.905V269.597L42.5848 284.247Z",
    fill: "url(#paint6_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1849 268.424V270.732L12.1211 268.967V266.659L15.1849 268.424Z",
    fill: "url(#paint7_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0488 281.222L60.0461 280.068V284.335L58.0488 285.488V281.222Z",
    fill: "#F7F7FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 278.857L64.1497 277.703V281.969L62.1523 283.123V278.857Z",
    fill: "#C0162E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69336 263.518C4.69336 262.587 5.34298 262.209 6.15743 262.674C6.97187 263.14 7.62149 264.274 7.62149 265.205C7.62149 266.136 6.97187 266.514 6.15743 266.048C5.34298 265.583 4.69336 264.458 4.69336 263.518Z",
    fill: "#59595B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 278.963L0 250.933V237.117L48.5465 265.147V278.963Z",
    fill: "#292929"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1032 250.933L48.5469 278.963V265.147L97.1032 237.117V250.933Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 265.147L0 237.116L48.5465 209.086L97.1028 237.116L48.5465 265.147Z",
    fill: "#313131"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9492 266.805L55.9465 265.651V269.917L53.9492 271.071V266.805Z",
    fill: "#F7F7FC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5848 267.454V269.762L17.2207 255.121V252.814L42.5848 267.454Z",
    fill: "url(#paint8_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1849 251.641V253.948L12.1211 252.184V249.876L15.1849 251.641Z",
    fill: "url(#paint9_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0488 264.439L60.0461 263.285V267.551L58.0488 268.705V264.439Z",
    fill: "#59595B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 262.073L64.1497 260.919V265.176L62.1523 266.33V262.073Z",
    fill: "#F7F7FC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69336 246.735C4.69336 245.804 5.34298 245.426 6.15743 245.891C6.96217 246.356 7.62149 247.491 7.62149 248.422C7.62149 249.352 6.97187 249.731 6.15743 249.265C5.34298 248.8 4.69336 247.665 4.69336 246.735Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M564.998 182.268H407.016V252.775H564.998V182.268Z",
    fill: "url(#paint10_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M332.076 316.777H174.094V387.284H332.076V316.777Z",
    fill: "url(#paint11_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M448.563 249.527H290.58V320.035H448.563V249.527Z",
    fill: "url(#paint12_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M346.01 105.419V217.521C346.01 226.538 351.973 235.565 363.898 242.449C375.824 249.333 391.444 252.775 407.074 252.775C422.703 252.775 438.323 249.333 450.249 242.449C462.174 235.565 468.128 226.548 468.128 217.521V105.419H346.01Z",
    fill: "#292929"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M450.239 80.4916L407.064 105.419H346C346 114.436 351.963 123.463 363.889 130.347C375.814 137.231 391.434 140.673 407.064 140.673C422.693 140.673 438.313 137.231 450.239 130.347C462.165 123.463 468.118 114.446 468.118 105.419C468.128 96.3926 462.165 87.3756 450.239 80.4916Z",
    fill: "#313131"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M407.064 70.1655C391.434 70.1655 375.814 73.6075 363.889 80.4915C351.963 87.3755 346 96.3925 346.01 105.419H407.074L429.829 72.6961C422.538 71.0091 414.801 70.1655 407.064 70.1655Z",
    fill: "url(#paint13_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M429.83 72.6962L407.074 105.419L450.249 80.4915C444.228 77.0108 437.257 74.422 429.83 72.6962Z",
    fill: "#CACACB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M229.527 172.669V284.771C229.527 293.788 235.49 302.815 247.416 309.699C259.342 316.583 274.962 320.025 290.591 320.025C306.221 320.025 321.841 316.583 333.766 309.699C345.692 302.815 351.645 293.798 351.645 284.771V172.669H229.527Z",
    fill: "#F1ECEC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M290.581 172.669L247.406 147.741C259.332 140.857 274.952 137.415 290.581 137.415C306.211 137.415 321.831 140.857 333.757 147.741C345.682 154.625 351.645 163.642 351.635 172.669C351.635 181.686 345.673 190.713 333.747 197.597C321.821 204.481 306.201 207.923 290.572 207.923C274.942 207.923 259.322 204.481 247.397 197.597C235.471 190.713 229.518 181.696 229.518 172.669H290.581Z",
    fill: "#CACACB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M229.527 172.669C229.527 163.652 235.49 154.625 247.416 147.741L290.591 172.669H229.527Z",
    fill: "#C0162E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M113.031 239.928V352.03C113.031 361.047 118.994 370.074 130.92 376.958C142.846 383.842 158.466 387.284 174.095 387.284V239.928H113.031Z",
    fill: "#F1ECEC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M174.096 239.928V387.284C189.725 387.284 205.345 383.842 217.271 376.958C229.197 370.074 235.15 361.057 235.15 352.03V239.928H174.096Z",
    fill: "#292929"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M217.271 215.001L174.096 239.928V275.182C189.725 275.182 205.345 271.74 217.271 264.856C229.197 257.972 235.15 248.955 235.15 239.928C235.15 230.902 229.187 221.885 217.271 215.001Z",
    fill: "#313131"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M217.27 215.001C205.344 208.117 189.725 204.675 174.095 204.675C158.466 204.675 142.846 208.117 130.92 215.001C118.994 221.884 113.031 230.902 113.041 239.928C113.041 248.945 119.004 257.972 130.93 264.856C142.855 271.74 158.475 275.182 174.105 275.182V239.928L217.27 215.001Z",
    fill: "#F7F7FC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M130.854 232.482C130.854 228.196 128.139 228.07 128.139 228.07C128.139 228.07 126.665 228.07 124.28 227.081C121.924 226.102 118.598 226.48 120.46 229.903C120.479 229.942 120.499 229.99 120.518 230.029C120.634 230.213 120.828 230.388 121.119 230.562L127.053 234.043C127.964 234.557 130.834 233.364 130.854 232.482Z",
    fill: "url(#paint14_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M130.844 232.094C130.795 232.976 127.955 234.15 127.063 233.636L121.129 230.155C120.935 230.039 120.595 229.816 120.295 229.544C120.353 229.66 120.402 229.777 120.469 229.903C120.489 229.942 120.508 229.99 120.528 230.029C120.644 230.213 120.838 230.388 121.129 230.562L127.063 234.043C127.906 234.528 130.485 233.51 130.825 232.656C130.844 232.589 130.854 232.53 130.854 232.482C130.854 232.346 130.844 232.22 130.844 232.094Z",
    fill: "#1E1C6B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M129.756 227.508C129.058 227.508 126.595 228.138 126.595 228.138C126.595 228.138 126.576 228.478 126.372 228.778C126.343 228.807 126.324 228.836 126.304 228.865C125.82 229.205 125.325 229.738 126.479 230.465C127.419 231.057 128.195 230.678 128.554 230.32C128.699 230.048 128.922 229.738 129.223 229.563C129.533 229.379 129.727 229.302 129.863 229.292C129.863 229.273 129.872 229.234 129.872 229.234C129.872 229.234 130.047 227.508 129.756 227.508Z",
    fill: "#FFD3AB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M152.902 221.196C151.797 217.211 150.507 213.944 149.431 209.27C146.852 208.756 124.096 201.766 123.97 206.565C123.834 211.491 126.5 228.39 126.5 228.39C126.549 228.584 126.704 228.768 126.956 228.914C127.606 229.282 128.653 229.282 129.293 228.914C129.584 228.749 129.826 228.526 129.855 228.303H129.865C129.865 228.303 129.729 216.28 129.293 211.132C136.361 216.62 148.636 222.612 152.902 221.196Z",
    fill: "#292929"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M122.429 238.241C122.429 233.955 119.714 233.829 119.714 233.829C119.714 233.829 118.24 233.829 115.855 232.84C113.499 231.861 110.174 232.239 112.025 235.662C112.045 235.701 112.064 235.749 112.093 235.788C112.21 235.972 112.404 236.147 112.694 236.321L118.628 239.802C119.53 240.316 122.41 239.123 122.429 238.241Z",
    fill: "#C0162E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M122.41 237.853C122.362 238.736 119.521 239.909 118.629 239.395L112.695 235.914C112.501 235.798 112.162 235.575 111.861 235.303C111.92 235.42 111.968 235.536 112.036 235.662C112.055 235.701 112.075 235.749 112.104 235.788C112.22 235.972 112.414 236.147 112.705 236.321L118.639 239.802C119.482 240.287 122.061 239.269 122.401 238.416C122.41 238.348 122.43 238.29 122.43 238.241C122.43 238.105 122.42 237.989 122.41 237.853Z",
    fill: "#292929"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M121.324 233.267C120.626 233.267 118.164 233.897 118.164 233.897C118.164 233.897 118.144 234.237 117.941 234.537C117.911 234.566 117.892 234.596 117.873 234.625C117.388 234.964 116.893 235.497 118.047 236.224C118.988 236.816 119.763 236.438 120.122 236.079C120.268 235.807 120.491 235.497 120.791 235.323C121.101 235.138 121.295 235.061 121.431 235.051C121.431 235.032 121.441 234.993 121.441 234.993C121.441 234.993 121.354 233.927 121.324 233.267Z",
    fill: "#FFD3AB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M141.182 215.185C138.602 214.671 117.921 204.994 115.895 208.95C115.798 209.135 115.759 209.348 115.759 209.581C114.77 214.584 118.067 234.15 118.067 234.15C118.115 234.343 118.271 234.528 118.523 234.673C119.172 235.051 120.219 235.042 120.859 234.673C121.15 234.508 121.393 234.285 121.422 234.062C121.422 234.062 122.508 221.429 122.168 216.901C129.372 223.125 140.193 226.8 144.207 226.703C151.789 226.509 155.396 222.544 157.034 218.132C157.626 216.532 157.907 212.266 157.907 210.424C150.286 206.643 143.693 211.161 141.182 215.185Z",
    fill: "#292929"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M217.272 215C205.346 208.116 189.727 204.674 174.097 204.674C168.706 204.674 163.325 205.091 158.089 205.906C158.051 207.37 157.992 208.873 157.925 210.424C157.925 212.276 157.643 216.532 157.052 218.132C155.404 222.544 151.797 226.509 144.224 226.703C140.686 226.79 131.882 223.949 124.92 219.024C124.377 219.451 123.863 219.877 123.359 220.314V220.304C120.295 222.941 117.91 225.772 116.204 228.7C116.175 228.749 116.165 228.797 116.136 228.836C114.08 232.424 113.033 236.166 113.033 239.918C113.033 248.935 118.996 257.962 130.922 264.846C142.848 271.73 158.467 275.172 174.097 275.172V239.918L217.272 215Z",
    fill: "#CACACB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M188.039 214.06C184.645 210.686 157.934 210.065 157.934 210.065C157.924 210.191 157.924 210.308 157.914 210.434C157.914 212.286 157.633 216.542 157.042 218.142C156.479 219.645 156.101 220.188 155.839 220.653C155.568 221.118 155.384 221.37 155.238 221.545C153.154 224.415 149.75 226.567 144.214 226.703C140.675 226.79 131.871 223.949 124.91 219.024C124.367 219.451 123.853 219.877 123.349 220.314V220.304C123.126 220.498 122.913 220.692 122.699 220.886C130.446 225.957 137.621 227.828 144.786 227.828C151.951 227.828 184.219 227.682 188.029 223.872C191.849 220.061 191.432 217.434 188.039 214.06Z",
    fill: "url(#paint15_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M116.679 208.999C114.847 204.48 113.111 200.156 111.463 196.035C111.356 195.774 111.501 195.444 111.783 195.279C118.531 191.381 121.905 189.433 128.663 185.535C128.76 185.477 128.857 185.457 128.954 185.457L128.963 185.448H128.556V185.457C128.459 185.457 128.353 185.467 128.256 185.535C121.507 189.433 118.133 191.381 111.375 195.279C111.104 195.434 110.959 195.774 111.055 196.035C112.694 200.156 114.439 204.48 116.272 208.999C116.349 209.193 116.524 209.289 116.708 209.289V209.299H117.144L117.125 209.289C116.941 209.289 116.766 209.193 116.679 208.999Z",
    fill: "#313131"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M134.587 198.711C134.684 198.973 134.539 199.313 134.267 199.477C127.519 203.375 124.145 205.324 117.397 209.222C117.125 209.377 116.805 209.29 116.689 208.999C114.856 204.48 113.121 200.156 111.473 196.035C111.366 195.774 111.511 195.444 111.793 195.279C118.541 191.382 121.915 189.433 128.673 185.535C128.944 185.38 129.264 185.448 129.371 185.71C131.136 189.908 132.978 194.484 134.587 198.711Z",
    fill: "#292929"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M111.975 195.745C112.304 196.569 116.745 207.622 117.113 208.524C118.034 207.99 133.102 199.351 134.023 198.828C133.693 197.975 129.214 186.844 128.865 186.01C127.934 186.543 112.896 195.211 111.975 195.745Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M123.446 198.518C122.835 196.995 123.456 195.143 124.823 194.368C126.19 193.592 127.809 194.193 128.41 195.715C129.021 197.238 128.372 199.051 127.005 199.826C125.637 200.602 124.047 200.04 123.446 198.518Z",
    fill: "#59595B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M119.809 201.591C119.199 200.078 119.819 198.217 121.186 197.441C122.553 196.666 124.173 197.276 124.774 198.789C125.375 200.301 124.725 202.085 123.358 202.861C121.991 203.637 120.42 203.094 119.809 201.591Z",
    fill: "#292929"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M119.557 196.966C118.956 195.483 119.615 193.728 120.973 192.942C122.34 192.157 123.911 192.652 124.512 194.145C125.123 195.638 124.512 197.519 123.135 198.294C121.768 199.07 120.158 198.45 119.557 196.966Z",
    fill: "#C0162E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M131.542 197.044C130.883 197.412 130.553 197.606 129.904 197.974C129.545 197.848 129.361 197.78 129.002 197.654C129.07 197.46 129.109 197.364 129.176 197.16C129.467 197.267 129.613 197.315 129.904 197.422C130.495 197.092 130.786 196.927 131.368 196.588C131.436 196.772 131.474 196.859 131.542 197.044Z",
    fill: "#C0162E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M118.53 194.882C118.239 194.794 118.103 194.746 117.812 194.659C117.231 194.998 116.93 195.163 116.348 195.502C116.281 195.337 116.251 195.25 116.184 195.085C116.843 194.707 117.163 194.523 117.822 194.145C118.171 194.251 118.355 194.3 118.705 194.416C118.637 194.6 118.608 194.697 118.53 194.882Z",
    fill: "#C0162E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M119.577 202.308C118.84 202.725 118.472 202.939 117.725 203.356C117.648 203.171 117.609 203.074 117.541 202.89C118.278 202.473 118.646 202.26 119.393 201.843C119.461 202.037 119.5 202.124 119.577 202.308Z",
    fill: "#C0162E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M128.75 216.348C129.021 216.503 129.477 216.503 129.758 216.348L146.619 206.614C146.89 206.458 146.89 206.197 146.619 206.032L135.129 199.4C134.858 199.245 134.402 199.245 134.121 199.4L117.26 209.134C116.989 209.29 116.989 209.551 117.26 209.716L128.75 216.348Z",
    fill: "#F7F7FC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M134.093 200.787L134.917 200.302L134.51 200.069L133.686 200.544L134.093 200.787Z",
    fill: "#EAEEF9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M132.706 201.582L133.53 201.106L133.123 200.874L132.299 201.349L132.706 201.582Z",
    fill: "#EAEEF9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M131.319 202.386L132.143 201.911L131.727 201.669L130.902 202.144L131.319 202.386Z",
    fill: "#EAEEF9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M129.934 203.191L130.759 202.716L130.342 202.474L129.518 202.949L129.934 203.191Z",
    fill: "#EAEEF9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M128.536 203.986L129.37 203.511L128.953 203.278L128.129 203.754L128.536 203.986Z",
    fill: "#EAEEF9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M127.149 204.791L127.974 204.316L127.566 204.073L126.742 204.549L127.149 204.791Z",
    fill: "#EAEEF9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M125.765 205.596L126.589 205.12L126.172 204.878L125.348 205.353L125.765 205.596Z",
    fill: "#EAEEF9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M124.378 206.391L125.202 205.916L124.785 205.683L123.961 206.158L124.378 206.391Z",
    fill: "#EAEEF9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M122.981 207.196L123.815 206.72L123.398 206.478L122.574 206.963L122.981 207.196Z",
    fill: "#EAEEF9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M121.593 208L122.417 207.525L122.01 207.283L121.186 207.758L121.593 208Z",
    fill: "#EAEEF9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M120.208 208.805L121.032 208.32L120.625 208.087L119.791 208.562L120.208 208.805Z",
    fill: "#EAEEF9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M118.821 209.6L119.645 209.125L119.228 208.892L118.404 209.367L118.821 209.6Z",
    fill: "#EAEEF9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M134.828 201.96L136.311 201.106L135.487 200.631L134.004 201.485L134.828 201.96Z",
    fill: "#EAEEF9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M135.596 203.055L137.641 201.872L136.817 201.397L134.771 202.58L135.596 203.055Z",
    fill: "#EAEEF9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M136.42 204.19L139.028 202.677L138.204 202.202L135.596 203.705L136.42 204.19Z",
    fill: "#EAEEF9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M139.23 204.5L140.714 203.647L139.589 203.007L138.115 203.86L139.23 204.5Z",
    fill: "#EAEEF9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M137.187 205.683L138.671 204.83L137.546 204.19L136.062 205.043L137.187 205.683Z",
    fill: "#EAEEF9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M135.138 206.866L136.612 206.013L135.497 205.363L134.014 206.226L135.138 206.866Z",
    fill: "#EAEEF9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M128.082 210.938L129.565 210.085L128.44 209.445L126.957 210.298L128.082 210.938Z",
    fill: "#EAEEF9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M124.609 212.945L127.518 211.268L126.403 210.618L123.494 212.305L124.609 212.945Z",
    fill: "#EAEEF9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M130.115 209.765L134.565 207.195L133.45 206.546L129 209.115L130.115 209.765Z",
    fill: "#EAEEF9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M133.055 202.988L134.266 202.29L133.442 201.814L132.221 202.513L133.055 202.988Z",
    fill: "#EAEEF9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M133.82 204.083L135.032 203.385L134.208 202.91L132.996 203.608L133.82 204.083Z",
    fill: "#EAEEF9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M134.605 205.188L135.817 204.49L134.993 204.015L133.781 204.713L134.605 205.188Z",
    fill: "#EAEEF9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M132.82 206.216L134.042 205.518L133.208 205.043L131.996 205.741L132.82 206.216Z",
    fill: "#EAEEF9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M131.047 207.244L132.259 206.546L131.435 206.071L130.223 206.769L131.047 207.244Z",
    fill: "#EAEEF9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M129.273 208.272L130.485 207.564L129.661 207.089L128.449 207.797L129.273 208.272Z",
    fill: "#EAEEF9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M127.488 209.299L128.71 208.592L127.876 208.117L126.664 208.815L127.488 209.299Z",
    fill: "#EAEEF9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M125.715 210.317L126.927 209.619L126.103 209.144L124.891 209.842L125.715 210.317Z",
    fill: "#EAEEF9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M122.893 211.956L125.152 210.647L124.327 210.172L122.068 211.481L122.893 211.956Z",
    fill: "#EAEEF9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M132.037 205.111L133.249 204.413L132.425 203.938L131.213 204.636L132.037 205.111Z",
    fill: "#EAEEF9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M130.262 206.139L131.474 205.441L130.649 204.956L129.438 205.664L130.262 206.139Z",
    fill: "#EAEEF9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M128.488 207.166L129.7 206.459L128.876 205.984L127.664 206.691L128.488 207.166Z",
    fill: "#EAEEF9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M126.705 208.194L127.917 207.486L127.093 207.011L125.881 207.709L126.705 208.194Z",
    fill: "#EAEEF9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M124.93 209.212L126.142 208.514L125.317 208.039L124.105 208.737L124.93 209.212Z",
    fill: "#EAEEF9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M121.539 211.171L124.37 209.542L123.546 209.067L120.715 210.696L121.539 211.171Z",
    fill: "#EAEEF9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M131.269 204.015L132.481 203.317L131.657 202.842L130.445 203.54L131.269 204.015Z",
    fill: "#EAEEF9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M129.496 205.043L130.708 204.345L129.884 203.87L128.672 204.568L129.496 205.043Z",
    fill: "#EAEEF9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M127.722 206.071L128.934 205.373L128.11 204.888L126.889 205.596L127.722 206.071Z",
    fill: "#EAEEF9"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M125.937 207.099L127.149 206.391L126.325 205.916L125.113 206.624L125.937 207.099Z",
    fill: "#EAEEF9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M124.164 208.117L125.376 207.418L124.552 206.943L123.34 207.641L124.164 208.117Z",
    fill: "#EAEEF9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M122.389 209.144L123.6 208.446L122.776 207.971L121.555 208.669L122.389 209.144Z",
    fill: "#EAEEF9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M120.207 210.405L121.816 209.474L120.992 208.999L119.383 209.93L120.207 210.405Z",
    fill: "#EAEEF9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M119.421 208.349L132.743 200.651L132.345 200.418L119.023 208.116L119.421 208.349Z",
    fill: "#292929"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M130.117 210.754L136.924 206.827L141.141 209.27L134.345 213.197L130.117 210.754Z",
    fill: "#EAEEF9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M117.251 209.716L128.74 216.348C128.963 216.474 129.293 216.503 129.554 216.426C129.554 216.426 129.719 216.358 129.748 216.348L146.609 206.613C146.629 206.604 146.648 206.594 146.658 206.575L146.667 206.565C146.677 206.555 146.687 206.546 146.696 206.546L146.706 206.536C146.716 206.526 146.726 206.517 146.735 206.507C146.745 206.497 146.755 206.478 146.764 206.468C146.784 206.429 146.803 206.39 146.803 206.352V206.594C146.803 206.701 146.735 206.807 146.599 206.885L129.739 216.62C129.341 216.823 128.759 216.784 128.595 216.746C128.42 216.707 128.275 216.668 128.09 216.629L117.251 210.366C117.115 210.288 117.047 210.182 117.047 210.075V209.445C117.047 209.532 117.115 209.639 117.251 209.716Z",
    fill: "url(#paint16_linear)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M137.347 202.939L134.768 204.432L142.582 208.941V209.202L145.161 207.709V207.447L137.347 202.939Z",
    fill: "url(#paint17_linear)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M147.424 185.506C147.172 187.455 147.521 189.879 144.399 195.59C143.41 197.393 139.706 202.386 138.387 203.239C137.99 202.6 136.332 201.95 136.031 201.785C135.731 201.62 134.713 201.504 134.131 201.863C133.995 201.94 133.559 202.192 133.229 202.464C132.677 202.9 133.21 203.346 133.83 203.278C134.451 203.21 134.606 203.385 135.217 203.889C135.324 203.976 135.42 204.083 135.508 204.19C135.149 204.044 134.587 203.647 134.179 204.112C134.519 204.335 135.682 204.946 136.623 205.072C136.885 205.12 137.961 205.082 138.407 205.004C140.385 204.684 144.816 201.872 147.802 197.829C152.95 190.848 153.416 187.94 153.426 186.194C153.464 181.521 147.754 182.297 147.424 185.506Z",
    fill: "url(#paint18_linear)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M151.562 219.363C145.211 222.922 137.115 221.467 140.102 214.273C141.721 210.821 142.37 204.791 142.244 201.184C141.653 199.836 139.762 199.409 138.861 195.851C138.657 193.098 138.618 192.021 139.142 186.611C141.43 183.906 142.497 182.665 145.056 181.657C146.598 181.046 148.605 180.27 150.079 181.172C156.468 185.108 158.504 197.024 157.913 210.424C157.253 214.806 154.694 217.608 151.562 219.363Z",
    fill: "#292929"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M148.683 181.744C147.636 180.687 147.278 178.331 147.161 176.46C147.307 175.432 147.287 174.336 147.045 173.212C146.172 169.178 142.914 166.463 139.754 167.142C136.603 167.821 134.741 171.641 135.614 175.674C136.418 179.407 139.502 181.56 142.401 181.967C142.701 182.549 141.945 183.508 141.528 183.964C143.894 184.682 146.269 183.295 147.471 182.694C148.092 182.384 148.538 182.083 148.683 181.744Z",
    fill: "#FFD3AB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M129.566 210.085L129.091 210.172C128.694 210.172 128.296 210.395 126.599 209.794C126.124 209.619 125.465 208.999 124.932 208.989C124.35 208.989 123.904 208.95 123.594 208.892C123.894 208.999 124.34 209.096 124.932 209.183C125.455 209.26 126.027 209.978 126.473 210.211C126.745 210.356 126.968 210.453 127.171 210.55L133.493 214.196V214.448L136.479 212.722V212.47L131.234 209.445C130.575 209.794 130.003 210.017 129.566 210.085Z",
    fill: "url(#paint19_linear)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M139.02 187.348C138.768 189.297 138.68 194.562 135.558 200.263C134.569 202.066 131.37 207.602 129.712 208.116C129.469 208.068 129.179 208.01 128.771 207.535C128.199 206.846 127.579 206.391 127.191 206.1C126.793 206.371 127.395 207.108 127.744 207.409C127.744 207.409 127.055 207.186 126.406 206.933C126.066 206.807 124.505 206.672 124.272 206.681C122.857 206.759 122.585 207.108 123.477 207.253C121.975 207.215 122.479 207.709 122.944 207.806C122.43 208.019 122.508 208.359 123.322 208.398C122.663 208.698 123.245 208.979 124.922 208.989C125.455 208.989 126.115 209.619 126.59 209.794C128.287 210.405 128.684 210.172 129.082 210.172L129.557 210.085C131.535 209.765 135.966 206.546 138.952 202.503C144.1 195.522 145.002 189.782 145.021 188.027C145.05 183.363 139.349 184.139 139.02 187.348Z",
    fill: "url(#paint20_linear)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M153.416 184.449C153.61 182.335 151.981 181.56 150.216 179.97C147.434 177.458 149.276 177.866 147.967 173.163C146.658 168.461 142.799 165.028 137.835 166.725C135.324 167.588 133.83 171.68 136.41 174.753C140.123 177.749 137.651 179.931 138.417 180.891C139.231 181.918 139.822 180.842 140.278 182.335C140.734 183.799 138.64 185.06 139.153 186.621C140.133 186.136 142.111 185.39 143.536 187.949C144.554 189.772 141.674 194.552 146.357 193.563C151.04 192.574 151.215 190.994 150.061 189.917C148.907 188.841 152.466 188.366 151.157 186.892C149.848 185.419 153.241 186.311 153.416 184.449Z",
    fill: "#AF7120"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M484.748 312.055H446.867L470.913 325.929L446.867 339.814H484.748L508.784 325.929L484.748 312.055Z",
    fill: "url(#paint21_linear)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M446.869 339.814L470.915 325.929V298.18L446.869 312.055V339.814Z",
    fill: "#CACACB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M446.87 339.814L422.834 325.929V298.18L446.87 312.055V339.814Z",
    fill: "#F1ECEC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M446.87 312.055L422.834 298.18L446.87 284.306L470.915 298.18L446.87 312.055Z",
    fill: "#59595B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M459.707 291.703H442.041L453.249 298.18L442.041 304.647H459.707L470.915 298.18L459.707 291.703Z",
    fill: "url(#paint22_linear)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M442.043 304.647L453.251 298.18V285.236L442.043 291.703V304.647Z",
    fill: "#CACACB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M442.042 304.647L430.844 298.18V285.236L442.042 291.703V304.647Z",
    fill: "#F1ECEC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M442.042 291.703L430.844 285.236L442.042 278.76L453.251 285.236L442.042 291.703Z",
    fill: "#59595B"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M485.67 362.23H468.014L479.222 368.707L468.014 375.174H485.67L496.878 368.707L485.67 362.23Z",
    fill: "url(#paint23_linear)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M127.511 467.177H107.848L120.326 474.381L107.848 481.595H127.511L139.999 474.381L127.511 467.177Z",
    fill: "url(#paint24_linear)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M107.848 481.595L120.326 474.381V459.973L107.848 467.177V481.595Z",
    fill: "#CACACB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M107.847 481.595L95.3594 474.381V459.973L107.847 467.177V481.595Z",
    fill: "#F1ECEC"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M107.847 467.177L95.3594 459.973L107.847 452.759L120.326 459.973L107.847 467.177Z",
    fill: "#59595B"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M470.916 375.562L480.877 369.803V358.302L470.916 364.053V375.562Z",
    fill: "#CACACB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M470.916 375.562L460.947 369.803V358.302L470.916 364.053V375.562Z",
    fill: "#F1ECEC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M470.916 364.053L460.947 358.302L470.916 352.544L480.877 358.302L470.916 364.053Z",
    fill: "#59595B"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M177.484 452.963H164.898L172.888 457.578L164.898 462.193H177.484L185.473 457.578L177.484 452.963Z",
    fill: "url(#paint25_linear)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M164.896 462.193L172.886 457.578V448.358L164.896 452.963V462.193Z",
    fill: "#59595B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M164.896 462.193L156.906 457.578V448.358L164.896 452.963V462.193Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M164.896 452.963L156.906 448.358L164.896 443.742L172.885 448.358L164.896 452.963Z",
    fill: "#292929"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M539.938 203.938H521.826L533.316 210.579L521.826 217.211H539.938L551.427 210.579L539.938 203.938Z",
    fill: "url(#paint26_linear)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M524.688 216.833L533.162 211.938V202.158L524.688 207.043V216.833Z",
    fill: "#59595B"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M524.687 216.833L516.213 211.938V202.158L524.687 207.043V216.833Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M524.687 207.042L516.213 202.158L524.687 197.262L533.161 202.158L524.687 207.042Z",
    fill: "#292929"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M514.736 3.38126L509.103 6.62933C505.816 8.52969 501.288 -1.83505 497.613 0.288317L487.753 5.97971C480.394 10.2264 483.05 -2.13562 472.055 4.2151C459.131 11.6808 460.188 26.6607 452.829 30.9075L442.968 36.5989C439.293 38.7222 438.285 47.5163 434.998 49.4166L429.365 52.6647C428.143 53.3725 425.797 55.331 425.797 57.8907C427.465 56.9211 472.055 31.1886 472.055 31.1886C472.055 31.1886 516.636 5.44645 518.314 4.48657C518.304 1.9269 515.958 2.67347 514.736 3.38126Z",
    fill: "url(#paint27_linear)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M265.877 107.882C265.877 111.052 263.628 114.94 260.894 116.521L173.652 166.89C170.908 168.471 168.668 167.181 168.668 164.011V90.4199C168.668 87.2494 170.908 83.3614 173.652 81.781L260.894 31.4116C263.638 29.8312 265.877 31.1207 265.877 34.2912V107.882Z",
    fill: "url(#paint28_linear)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M179.14 149.816L177.734 150.621V123.298L179.14 122.493V149.816Z",
    fill: "#59595B"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M184.646 134.322L183.24 135.137V112.003L184.646 111.198V134.322Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M189.447 137.367L188.041 138.181V115.726L189.447 114.911V137.367Z",
    fill: "#59595B"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M195.654 144.192L194.248 145.007V129.387L195.654 128.573V144.192Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M201.16 135.34L199.754 136.145V110.044L201.16 109.229V135.34Z",
    fill: "#59595B"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M206.668 124.588L205.262 125.392V98.7484L206.668 97.934V124.588Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M212.173 115.726L210.768 116.54V86.9101L212.173 86.1053V115.726Z",
    fill: "#59595B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M217.679 131.481L216.273 132.296V91.3119L217.679 90.4974V131.481Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M243.026 81.558C235.589 85.8532 229.559 96.2955 229.559 104.886C229.559 113.476 235.589 116.957 243.026 112.662C250.463 108.367 256.493 97.9244 256.493 89.334L243.026 97.11V81.558Z",
    fill: "#59595B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M243.025 81.558V97.11L256.493 89.334C256.493 80.7436 250.462 77.2628 243.025 81.558Z",
    fill: "#C0162E"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M178.433 115.328C177.056 116.123 175.941 115.474 175.941 113.893C175.941 112.303 177.056 110.374 178.433 109.579C179.81 108.784 180.925 109.433 180.925 111.014C180.925 112.594 179.81 114.533 178.433 115.328ZM178.433 110.539C177.522 111.062 176.785 112.352 176.785 113.399C176.785 114.456 177.522 114.882 178.433 114.349C179.345 113.825 180.082 112.536 180.082 111.489C180.091 110.442 179.345 110.015 178.433 110.539Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M188.75 95.0157C187.373 95.8108 186.258 95.1611 186.258 93.5807C186.258 91.9906 187.373 90.0612 188.75 89.2661C190.126 88.4711 191.241 89.1207 191.241 90.7011C191.241 92.2815 190.117 94.2207 188.75 95.0157ZM188.75 90.226C187.838 90.7496 187.092 92.0391 187.092 93.0863C187.092 94.1431 187.829 94.5697 188.75 94.0364C189.661 93.5129 190.398 92.2233 190.398 91.1762C190.398 90.1291 189.651 89.7024 188.75 90.226Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M200.464 98.2347C199.088 99.0298 197.973 98.3801 197.973 96.7997C197.973 95.2096 199.088 93.2802 200.464 92.4851C201.841 91.6901 202.956 92.3397 202.956 93.9201C202.956 95.5005 201.841 97.4397 200.464 98.2347ZM200.464 93.445C199.553 93.9686 198.806 95.2581 198.806 96.3052C198.806 97.3621 199.543 97.7887 200.464 97.2554C201.376 96.7319 202.113 95.4423 202.113 94.3952C202.113 93.348 201.376 92.9215 200.464 93.445Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M211.476 74.2862C210.099 75.0813 208.984 74.4316 208.984 72.8512C208.984 71.2611 210.099 69.3317 211.476 68.5366C212.853 67.7416 213.968 68.3912 213.968 69.9716C213.968 71.5617 212.843 73.4912 211.476 74.2862ZM211.476 69.5062C210.565 70.0298 209.828 71.3193 209.828 72.3664C209.828 73.4233 210.565 73.8499 211.476 73.3166C212.388 72.7931 213.124 71.5035 213.124 70.4564C213.124 69.4093 212.388 68.9729 211.476 69.5062Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M224.052 84.4377C222.676 85.2327 221.561 84.5831 221.561 83.0027C221.561 81.4126 222.676 79.4832 224.052 78.6881C225.429 77.8931 226.544 78.5427 226.544 80.1231C226.544 81.7035 225.429 83.6426 224.052 84.4377ZM224.052 79.648C223.141 80.1716 222.404 81.4611 222.404 82.5083C222.404 83.5651 223.141 83.9917 224.052 83.4584C224.964 82.9348 225.701 81.6453 225.701 80.5982C225.71 79.5511 224.964 79.1244 224.052 79.648Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M232.904 67.858C231.527 68.653 230.412 68.0034 230.412 66.423C230.412 64.8329 231.527 62.9035 232.904 62.1084C234.281 61.3134 235.396 61.963 235.396 63.5434C235.396 65.1238 234.271 67.0629 232.904 67.858ZM232.904 63.0683C231.993 63.5919 231.256 64.8814 231.256 65.9285C231.256 66.9854 231.993 67.412 232.904 66.8787C233.815 66.3552 234.552 65.0656 234.552 64.0185C234.552 62.9713 233.815 62.5447 232.904 63.0683Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M231.112 67.3352L225.018 78.7654L225.873 79.2216L231.968 67.7914L231.112 67.3352Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M213.095 72.0697L212.486 72.8245L222.418 80.8349L223.027 80.0802L213.095 72.0697Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M209.82 73.8529L201.23 92.5162L202.111 92.9216L210.701 74.2583L209.82 73.8529Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M190.507 92.1133L190.25 93.0482L198.637 95.3512L198.893 94.4162L190.507 92.1133Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M186.983 94.4721L179.324 109.592L180.189 110.03L187.848 94.9103L186.983 94.4721Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M260.74 42.6877L250.938 48.3403V45.4316L260.74 39.7789V42.6877Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M260.74 48.1464L255.01 51.4526V48.5439L260.74 45.2377V48.1464Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M114.314 352.505L94.5738 341.113C89.1151 337.962 89.1151 332.823 94.5738 329.672L103.31 324.63C105.065 323.612 105.065 321.964 103.31 320.946L79.8848 307.42",
    stroke: "#C0162E"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2461 305.481L106.671 319.007C110.287 321.091 110.287 324.485 106.671 326.569L97.9351 331.611C94.3186 333.696 94.3186 337.089 97.9351 339.174L117.676 350.566",
    stroke: "#C0162E"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M130.621 273.262H106.702L104.123 274.746L101.554 273.262H77.6245L75.0454 274.746L72.476 273.262H48.5469L63.0905 281.649V320.926L48.5469 329.323H72.476L75.0454 327.84L77.6245 329.323H101.554L104.123 327.84L106.702 329.323H130.621L179.178 301.293L130.621 273.262Z",
    fill: "url(#paint29_linear)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 329.323L0 301.293V287.476L48.5465 315.507V329.323Z",
    fill: "#292929"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1032 301.293L48.5469 329.323V315.507L97.1032 287.476V301.293Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 315.507L0 287.476L48.5465 259.446L97.1028 287.476L48.5465 315.507Z",
    fill: "#313131"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9492 317.165L55.9465 316.011V320.277L53.9492 321.431V317.165Z",
    fill: "#59595B"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5848 317.824V320.122L17.2207 305.481V303.174L42.5848 317.824Z",
    fill: "url(#paint30_linear)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1849 302V304.308L12.1211 302.543V300.236L15.1849 302Z",
    fill: "url(#paint31_linear)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0488 314.799L60.0461 313.645V317.911L58.0488 319.065V314.799Z",
    fill: "#59595B"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 312.433L64.1497 311.279V315.545L62.1523 316.689V312.433Z",
    fill: "#F7F7FC"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69336 297.094C4.69336 296.164 5.34298 295.786 6.15743 296.251C6.96217 296.716 7.62149 297.851 7.62149 298.782C7.62149 299.712 6.97187 300.09 6.15743 299.625C5.35268 299.16 4.69336 298.025 4.69336 297.094Z",
    fill: "#59595B"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 312.54L0 284.5V270.693L48.5465 298.723V312.54Z",
    fill: "#292929"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1032 284.5L48.5469 312.54V298.723L97.1032 270.693V284.5Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 298.723L0 270.693L48.5465 242.662L97.1028 270.693L48.5465 298.723Z",
    fill: "#313131"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9492 300.381L55.9465 299.227V303.493L53.9492 304.647V300.381Z",
    fill: "#C0162E"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5848 301.031V303.338L17.2207 288.698V286.39L42.5848 301.031Z",
    fill: "url(#paint32_linear)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1849 285.217V287.515L12.1211 285.75V283.443L15.1849 285.217Z",
    fill: "url(#paint33_linear)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0488 298.015L60.0461 296.862V301.128L58.0488 302.281V298.015Z",
    fill: "#59595B"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 295.64L64.1497 294.486V298.752L62.1523 299.906V295.64Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69336 280.311C4.69336 279.38 5.34298 279.002 6.15743 279.468C6.96217 279.933 7.62149 281.067 7.62149 281.998C7.62149 282.929 6.97187 283.307 6.15743 282.842C5.35268 282.376 4.69336 281.242 4.69336 280.311Z",
    fill: "url(#paint34_linear)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 295.747L0 267.716V253.909L48.5465 281.94V295.747Z",
    fill: "#292929"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1032 267.716L48.5469 295.747V281.94L97.1032 253.909V267.716Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 281.94L0 253.909L48.5465 225.869L97.1028 253.909L48.5465 281.94Z",
    fill: "#313131"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9492 283.598L55.9465 282.444V286.71L53.9492 287.864V283.598Z",
    fill: "#59595B"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5848 284.247V286.555L17.2207 271.905V269.597L42.5848 284.247Z",
    fill: "url(#paint35_linear)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1849 268.424V270.732L12.1211 268.967V266.659L15.1849 268.424Z",
    fill: "url(#paint36_linear)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0488 281.222L60.0461 280.068V284.335L58.0488 285.488V281.222Z",
    fill: "#F7F7FC"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 278.857L64.1497 277.703V281.969L62.1523 283.123V278.857Z",
    fill: "#C0162E"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69336 263.518C4.69336 262.587 5.34298 262.209 6.15743 262.674C6.97187 263.14 7.62149 264.274 7.62149 265.205C7.62149 266.136 6.97187 266.514 6.15743 266.048C5.34298 265.583 4.69336 264.458 4.69336 263.518Z",
    fill: "#59595B"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 278.963L0 250.933V237.117L48.5465 265.147V278.963Z",
    fill: "#292929"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1032 250.933L48.5469 278.963V265.147L97.1032 237.117V250.933Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5465 265.147L0 237.116L48.5465 209.086L97.1028 237.116L48.5465 265.147Z",
    fill: "#313131"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9492 266.805L55.9465 265.651V269.917L53.9492 271.071V266.805Z",
    fill: "#F7F7FC"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5848 267.454V269.762L17.2207 255.121V252.814L42.5848 267.454Z",
    fill: "url(#paint37_linear)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1849 251.641V253.948L12.1211 252.184V249.876L15.1849 251.641Z",
    fill: "url(#paint38_linear)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0488 264.439L60.0461 263.285V267.551L58.0488 268.705V264.439Z",
    fill: "#59595B"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 262.073L64.1497 260.919V265.176L62.1523 266.33V262.073Z",
    fill: "#F7F7FC"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69336 246.735C4.69336 245.804 5.34298 245.426 6.15743 245.891C6.96217 246.356 7.62149 247.491 7.62149 248.422C7.62149 249.352 6.97187 249.731 6.15743 249.265C5.34298 248.8 4.69336 247.665 4.69336 246.735Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M564.998 182.268H407.016V252.775H564.998V182.268Z",
    fill: "url(#paint39_linear)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M332.076 316.777H174.094V387.284H332.076V316.777Z",
    fill: "url(#paint40_linear)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M448.563 249.527H290.58V320.035H448.563V249.527Z",
    fill: "url(#paint41_linear)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M346.01 105.419V217.521C346.01 226.538 351.973 235.565 363.898 242.449C375.824 249.333 391.444 252.775 407.074 252.775C422.703 252.775 438.323 249.333 450.249 242.449C462.174 235.565 468.128 226.548 468.128 217.521V105.419H346.01Z",
    fill: "#292929"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M450.239 80.4916L407.064 105.419H346C346 114.436 351.963 123.463 363.889 130.347C375.814 137.231 391.434 140.673 407.064 140.673C422.693 140.673 438.313 137.231 450.239 130.347C462.165 123.463 468.118 114.446 468.118 105.419C468.128 96.3926 462.165 87.3756 450.239 80.4916Z",
    fill: "#313131"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M407.064 70.1655C391.434 70.1655 375.814 73.6075 363.889 80.4915C351.963 87.3755 346 96.3925 346.01 105.419H407.074L429.829 72.6961C422.538 71.0091 414.801 70.1655 407.064 70.1655Z",
    fill: "url(#paint42_linear)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M429.83 72.6962L407.074 105.419L450.249 80.4915C444.228 77.0108 437.257 74.422 429.83 72.6962Z",
    fill: "#CACACB"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M229.527 172.669V284.771C229.527 293.788 235.49 302.815 247.416 309.699C259.342 316.583 274.962 320.025 290.591 320.025C306.221 320.025 321.841 316.583 333.766 309.699C345.692 302.815 351.645 293.798 351.645 284.771V172.669H229.527Z",
    fill: "#F1ECEC"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M290.581 172.669L247.406 147.741C259.332 140.857 274.952 137.415 290.581 137.415C306.211 137.415 321.831 140.857 333.757 147.741C345.682 154.625 351.645 163.642 351.635 172.669C351.635 181.686 345.673 190.713 333.747 197.597C321.821 204.481 306.201 207.923 290.572 207.923C274.942 207.923 259.322 204.481 247.397 197.597C235.471 190.713 229.518 181.696 229.518 172.669H290.581Z",
    fill: "#CACACB"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M229.527 172.669C229.527 163.652 235.49 154.625 247.416 147.741L290.591 172.669H229.527Z",
    fill: "#C0162E"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M113.031 239.928V352.03C113.031 361.047 118.994 370.074 130.92 376.958C142.846 383.842 158.466 387.284 174.095 387.284V239.928H113.031Z",
    fill: "#F1ECEC"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M174.096 239.928V387.284C189.725 387.284 205.345 383.842 217.271 376.958C229.197 370.074 235.15 361.057 235.15 352.03V239.928H174.096Z",
    fill: "#292929"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M217.271 215.001L174.096 239.928V275.182C189.725 275.182 205.345 271.74 217.271 264.856C229.197 257.972 235.15 248.955 235.15 239.928C235.15 230.902 229.187 221.885 217.271 215.001Z",
    fill: "#313131"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M217.27 215.001C205.344 208.117 189.725 204.675 174.095 204.675C158.466 204.675 142.846 208.117 130.92 215.001C118.994 221.884 113.031 230.902 113.041 239.928C113.041 248.945 119.004 257.972 130.93 264.856C142.855 271.74 158.475 275.182 174.105 275.182V239.928L217.27 215.001Z",
    fill: "#F7F7FC"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M130.854 232.482C130.854 228.196 128.139 228.07 128.139 228.07C128.139 228.07 126.665 228.07 124.28 227.081C121.924 226.102 118.598 226.48 120.46 229.903C120.479 229.942 120.499 229.99 120.518 230.029C120.634 230.213 120.828 230.388 121.119 230.562L127.053 234.043C127.964 234.557 130.834 233.364 130.854 232.482Z",
    fill: "url(#paint43_linear)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M130.844 232.094C130.795 232.976 127.955 234.15 127.063 233.636L121.129 230.155C120.935 230.039 120.595 229.816 120.295 229.544C120.353 229.66 120.402 229.777 120.469 229.903C120.489 229.942 120.508 229.99 120.528 230.029C120.644 230.213 120.838 230.388 121.129 230.562L127.063 234.043C127.906 234.528 130.485 233.51 130.825 232.656C130.844 232.589 130.854 232.53 130.854 232.482C130.854 232.346 130.844 232.22 130.844 232.094Z",
    fill: "#1E1C6B"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M129.756 227.508C129.058 227.508 126.595 228.138 126.595 228.138C126.595 228.138 126.576 228.478 126.372 228.778C126.343 228.807 126.324 228.836 126.304 228.865C125.82 229.205 125.325 229.738 126.479 230.465C127.419 231.057 128.195 230.678 128.554 230.32C128.699 230.048 128.922 229.738 129.223 229.563C129.533 229.379 129.727 229.302 129.863 229.292C129.863 229.273 129.872 229.234 129.872 229.234C129.872 229.234 130.047 227.508 129.756 227.508Z",
    fill: "#FFD3AB"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M152.902 221.196C151.797 217.211 150.507 213.944 149.431 209.27C146.852 208.756 124.096 201.766 123.97 206.565C123.834 211.491 126.5 228.39 126.5 228.39C126.549 228.584 126.704 228.768 126.956 228.914C127.606 229.282 128.653 229.282 129.293 228.914C129.584 228.749 129.826 228.526 129.855 228.303H129.865C129.865 228.303 129.729 216.28 129.293 211.132C136.361 216.62 148.636 222.612 152.902 221.196Z",
    fill: "#292929"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M122.429 238.241C122.429 233.955 119.714 233.829 119.714 233.829C119.714 233.829 118.24 233.829 115.855 232.84C113.499 231.861 110.174 232.239 112.025 235.662C112.045 235.701 112.064 235.749 112.093 235.788C112.21 235.972 112.404 236.147 112.694 236.321L118.628 239.802C119.53 240.316 122.41 239.123 122.429 238.241Z",
    fill: "#C0162E"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M122.41 237.853C122.362 238.736 119.521 239.909 118.629 239.395L112.695 235.914C112.501 235.798 112.162 235.575 111.861 235.303C111.92 235.42 111.968 235.536 112.036 235.662C112.055 235.701 112.075 235.749 112.104 235.788C112.22 235.972 112.414 236.147 112.705 236.321L118.639 239.802C119.482 240.287 122.061 239.269 122.401 238.416C122.41 238.348 122.43 238.29 122.43 238.241C122.43 238.105 122.42 237.989 122.41 237.853Z",
    fill: "#292929"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M121.324 233.267C120.626 233.267 118.164 233.897 118.164 233.897C118.164 233.897 118.144 234.237 117.941 234.537C117.911 234.566 117.892 234.596 117.873 234.625C117.388 234.964 116.893 235.497 118.047 236.224C118.988 236.816 119.763 236.438 120.122 236.079C120.268 235.807 120.491 235.497 120.791 235.323C121.101 235.138 121.295 235.061 121.431 235.051C121.431 235.032 121.441 234.993 121.441 234.993C121.441 234.993 121.354 233.927 121.324 233.267Z",
    fill: "#FFD3AB"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M141.182 215.185C138.602 214.671 117.921 204.994 115.895 208.95C115.798 209.135 115.759 209.348 115.759 209.581C114.77 214.584 118.067 234.15 118.067 234.15C118.115 234.343 118.271 234.528 118.523 234.673C119.172 235.051 120.219 235.042 120.859 234.673C121.15 234.508 121.393 234.285 121.422 234.062C121.422 234.062 122.508 221.429 122.168 216.901C129.372 223.125 140.193 226.8 144.207 226.703C151.789 226.509 155.396 222.544 157.034 218.132C157.626 216.532 157.907 212.266 157.907 210.424C150.286 206.643 143.693 211.161 141.182 215.185Z",
    fill: "#292929"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M217.272 215C205.346 208.116 189.727 204.674 174.097 204.674C168.706 204.674 163.325 205.091 158.089 205.906C158.051 207.37 157.992 208.873 157.925 210.424C157.925 212.276 157.643 216.532 157.052 218.132C155.404 222.544 151.797 226.509 144.224 226.703C140.686 226.79 131.882 223.949 124.92 219.024C124.377 219.451 123.863 219.877 123.359 220.314V220.304C120.295 222.941 117.91 225.772 116.204 228.7C116.175 228.749 116.165 228.797 116.136 228.836C114.08 232.424 113.033 236.166 113.033 239.918C113.033 248.935 118.996 257.962 130.922 264.846C142.848 271.73 158.467 275.172 174.097 275.172V239.918L217.272 215Z",
    fill: "#CACACB"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M188.039 214.06C184.645 210.686 157.934 210.065 157.934 210.065C157.924 210.191 157.924 210.308 157.914 210.434C157.914 212.286 157.633 216.542 157.042 218.142C156.479 219.645 156.101 220.188 155.839 220.653C155.568 221.118 155.384 221.37 155.238 221.545C153.154 224.415 149.75 226.567 144.214 226.703C140.675 226.79 131.871 223.949 124.91 219.024C124.367 219.451 123.853 219.877 123.349 220.314V220.304C123.126 220.498 122.913 220.692 122.699 220.886C130.446 225.957 137.621 227.828 144.786 227.828C151.951 227.828 184.219 227.682 188.029 223.872C191.849 220.061 191.432 217.434 188.039 214.06Z",
    fill: "url(#paint44_linear)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M116.679 208.999C114.847 204.48 113.111 200.156 111.463 196.035C111.356 195.774 111.501 195.444 111.783 195.279C118.531 191.381 121.905 189.433 128.663 185.535C128.76 185.477 128.857 185.457 128.954 185.457L128.963 185.448H128.556V185.457C128.459 185.457 128.353 185.467 128.256 185.535C121.507 189.433 118.133 191.381 111.375 195.279C111.104 195.434 110.959 195.774 111.055 196.035C112.694 200.156 114.439 204.48 116.272 208.999C116.349 209.193 116.524 209.289 116.708 209.289V209.299H117.144L117.125 209.289C116.941 209.289 116.766 209.193 116.679 208.999Z",
    fill: "#313131"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M134.587 198.711C134.684 198.973 134.539 199.313 134.267 199.477C127.519 203.375 124.145 205.324 117.397 209.222C117.125 209.377 116.805 209.29 116.689 208.999C114.856 204.48 113.121 200.156 111.473 196.035C111.366 195.774 111.511 195.444 111.793 195.279C118.541 191.382 121.915 189.433 128.673 185.535C128.944 185.38 129.264 185.448 129.371 185.71C131.136 189.908 132.978 194.484 134.587 198.711Z",
    fill: "#292929"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M111.975 195.745C112.304 196.569 116.745 207.622 117.113 208.524C118.034 207.99 133.102 199.351 134.023 198.828C133.693 197.975 129.214 186.844 128.865 186.01C127.934 186.543 112.896 195.211 111.975 195.745Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M123.446 198.518C122.835 196.995 123.456 195.143 124.823 194.368C126.19 193.592 127.809 194.193 128.41 195.715C129.021 197.238 128.372 199.051 127.005 199.826C125.637 200.602 124.047 200.04 123.446 198.518Z",
    fill: "#59595B"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M119.809 201.591C119.199 200.078 119.819 198.217 121.186 197.441C122.553 196.666 124.173 197.276 124.774 198.789C125.375 200.301 124.725 202.085 123.358 202.861C121.991 203.637 120.42 203.094 119.809 201.591Z",
    fill: "#292929"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M119.557 196.966C118.956 195.483 119.615 193.728 120.973 192.942C122.34 192.157 123.911 192.652 124.512 194.145C125.123 195.638 124.512 197.519 123.135 198.294C121.768 199.07 120.158 198.45 119.557 196.966Z",
    fill: "#C0162E"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M131.542 197.044C130.883 197.412 130.553 197.606 129.904 197.974C129.545 197.848 129.361 197.78 129.002 197.654C129.07 197.46 129.109 197.364 129.176 197.16C129.467 197.267 129.613 197.315 129.904 197.422C130.495 197.092 130.786 196.927 131.368 196.588C131.436 196.772 131.474 196.859 131.542 197.044Z",
    fill: "#C0162E"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M118.53 194.882C118.239 194.794 118.103 194.746 117.812 194.659C117.231 194.998 116.93 195.163 116.348 195.502C116.281 195.337 116.251 195.25 116.184 195.085C116.843 194.707 117.163 194.523 117.822 194.145C118.171 194.251 118.355 194.3 118.705 194.416C118.637 194.6 118.608 194.697 118.53 194.882Z",
    fill: "#C0162E"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M119.577 202.308C118.84 202.725 118.472 202.939 117.725 203.356C117.648 203.171 117.609 203.074 117.541 202.89C118.278 202.473 118.646 202.26 119.393 201.843C119.461 202.037 119.5 202.124 119.577 202.308Z",
    fill: "#C0162E"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M128.75 216.348C129.021 216.503 129.477 216.503 129.758 216.348L146.619 206.614C146.89 206.458 146.89 206.197 146.619 206.032L135.129 199.4C134.858 199.245 134.402 199.245 134.121 199.4L117.26 209.134C116.989 209.29 116.989 209.551 117.26 209.716L128.75 216.348Z",
    fill: "#F7F7FC"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M134.093 200.787L134.917 200.302L134.51 200.069L133.686 200.544L134.093 200.787Z",
    fill: "#EAEEF9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M132.706 201.582L133.53 201.106L133.123 200.874L132.299 201.349L132.706 201.582Z",
    fill: "#EAEEF9"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M131.319 202.386L132.143 201.911L131.727 201.669L130.902 202.144L131.319 202.386Z",
    fill: "#EAEEF9"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M129.934 203.191L130.759 202.716L130.342 202.474L129.518 202.949L129.934 203.191Z",
    fill: "#EAEEF9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M128.536 203.986L129.37 203.511L128.953 203.278L128.129 203.754L128.536 203.986Z",
    fill: "#EAEEF9"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M127.149 204.791L127.974 204.316L127.566 204.073L126.742 204.549L127.149 204.791Z",
    fill: "#EAEEF9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M125.765 205.596L126.589 205.12L126.172 204.878L125.348 205.353L125.765 205.596Z",
    fill: "#EAEEF9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M124.378 206.391L125.202 205.916L124.785 205.683L123.961 206.158L124.378 206.391Z",
    fill: "#EAEEF9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M122.981 207.196L123.815 206.72L123.398 206.478L122.574 206.963L122.981 207.196Z",
    fill: "#EAEEF9"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M121.593 208L122.417 207.525L122.01 207.283L121.186 207.758L121.593 208Z",
    fill: "#EAEEF9"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M120.208 208.805L121.032 208.32L120.625 208.087L119.791 208.562L120.208 208.805Z",
    fill: "#EAEEF9"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M118.821 209.6L119.645 209.125L119.228 208.892L118.404 209.367L118.821 209.6Z",
    fill: "#EAEEF9"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M134.828 201.96L136.311 201.106L135.487 200.631L134.004 201.485L134.828 201.96Z",
    fill: "#EAEEF9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M135.596 203.055L137.641 201.872L136.817 201.397L134.771 202.58L135.596 203.055Z",
    fill: "#EAEEF9"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M136.42 204.19L139.028 202.677L138.204 202.202L135.596 203.705L136.42 204.19Z",
    fill: "#EAEEF9"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M139.23 204.5L140.714 203.647L139.589 203.007L138.115 203.86L139.23 204.5Z",
    fill: "#EAEEF9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M137.187 205.683L138.671 204.83L137.546 204.19L136.062 205.043L137.187 205.683Z",
    fill: "#EAEEF9"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M135.138 206.866L136.612 206.013L135.497 205.363L134.014 206.226L135.138 206.866Z",
    fill: "#EAEEF9"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M128.082 210.938L129.565 210.085L128.44 209.445L126.957 210.298L128.082 210.938Z",
    fill: "#EAEEF9"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M124.609 212.945L127.518 211.268L126.403 210.618L123.494 212.305L124.609 212.945Z",
    fill: "#EAEEF9"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M130.115 209.765L134.565 207.195L133.45 206.546L129 209.115L130.115 209.765Z",
    fill: "#EAEEF9"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M133.055 202.988L134.266 202.29L133.442 201.814L132.221 202.513L133.055 202.988Z",
    fill: "#EAEEF9"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M133.82 204.083L135.032 203.385L134.208 202.91L132.996 203.608L133.82 204.083Z",
    fill: "#EAEEF9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M134.605 205.188L135.817 204.49L134.993 204.015L133.781 204.713L134.605 205.188Z",
    fill: "#EAEEF9"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M132.82 206.216L134.042 205.518L133.208 205.043L131.996 205.741L132.82 206.216Z",
    fill: "#EAEEF9"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M131.047 207.244L132.259 206.546L131.435 206.071L130.223 206.769L131.047 207.244Z",
    fill: "#EAEEF9"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M129.273 208.272L130.485 207.564L129.661 207.089L128.449 207.797L129.273 208.272Z",
    fill: "#EAEEF9"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M127.488 209.299L128.71 208.592L127.876 208.117L126.664 208.815L127.488 209.299Z",
    fill: "#EAEEF9"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M125.715 210.317L126.927 209.619L126.103 209.144L124.891 209.842L125.715 210.317Z",
    fill: "#EAEEF9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M122.893 211.956L125.152 210.647L124.327 210.172L122.068 211.481L122.893 211.956Z",
    fill: "#EAEEF9"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M132.037 205.111L133.249 204.413L132.425 203.938L131.213 204.636L132.037 205.111Z",
    fill: "#EAEEF9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M130.262 206.139L131.474 205.441L130.649 204.956L129.438 205.664L130.262 206.139Z",
    fill: "#EAEEF9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M128.488 207.166L129.7 206.459L128.876 205.984L127.664 206.691L128.488 207.166Z",
    fill: "#EAEEF9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M126.705 208.194L127.917 207.486L127.093 207.011L125.881 207.709L126.705 208.194Z",
    fill: "#EAEEF9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M124.93 209.212L126.142 208.514L125.317 208.039L124.105 208.737L124.93 209.212Z",
    fill: "#EAEEF9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M121.539 211.171L124.37 209.542L123.546 209.067L120.715 210.696L121.539 211.171Z",
    fill: "#EAEEF9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M131.269 204.015L132.481 203.317L131.657 202.842L130.445 203.54L131.269 204.015Z",
    fill: "#EAEEF9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M129.496 205.043L130.708 204.345L129.884 203.87L128.672 204.568L129.496 205.043Z",
    fill: "#EAEEF9"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M127.722 206.071L128.934 205.373L128.11 204.888L126.889 205.596L127.722 206.071Z",
    fill: "#EAEEF9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M125.937 207.099L127.149 206.391L126.325 205.916L125.113 206.624L125.937 207.099Z",
    fill: "#EAEEF9"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M124.164 208.117L125.376 207.418L124.552 206.943L123.34 207.641L124.164 208.117Z",
    fill: "#EAEEF9"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M122.389 209.144L123.6 208.446L122.776 207.971L121.555 208.669L122.389 209.144Z",
    fill: "#EAEEF9"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M120.207 210.405L121.816 209.474L120.992 208.999L119.383 209.93L120.207 210.405Z",
    fill: "#EAEEF9"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M119.421 208.349L132.743 200.651L132.345 200.418L119.023 208.116L119.421 208.349Z",
    fill: "#292929"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M130.117 210.754L136.924 206.827L141.141 209.27L134.345 213.197L130.117 210.754Z",
    fill: "#EAEEF9"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M117.251 209.716L128.74 216.348C128.963 216.474 129.293 216.503 129.554 216.426C129.554 216.426 129.719 216.358 129.748 216.348L146.609 206.613C146.629 206.604 146.648 206.594 146.658 206.575L146.667 206.565C146.677 206.555 146.687 206.546 146.696 206.546L146.706 206.536C146.716 206.526 146.726 206.517 146.735 206.507C146.745 206.497 146.755 206.478 146.764 206.468C146.784 206.429 146.803 206.39 146.803 206.352V206.594C146.803 206.701 146.735 206.807 146.599 206.885L129.739 216.62C129.341 216.823 128.759 216.784 128.595 216.746C128.42 216.707 128.275 216.668 128.09 216.629L117.251 210.366C117.115 210.288 117.047 210.182 117.047 210.075V209.445C117.047 209.532 117.115 209.639 117.251 209.716Z",
    fill: "url(#paint45_linear)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M137.347 202.939L134.768 204.432L142.582 208.941V209.202L145.161 207.709V207.447L137.347 202.939Z",
    fill: "url(#paint46_linear)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M147.424 185.506C147.172 187.455 147.521 189.879 144.399 195.59C143.41 197.393 139.706 202.386 138.387 203.239C137.99 202.6 136.332 201.95 136.031 201.785C135.731 201.62 134.713 201.504 134.131 201.863C133.995 201.94 133.559 202.192 133.229 202.464C132.677 202.9 133.21 203.346 133.83 203.278C134.451 203.21 134.606 203.385 135.217 203.889C135.324 203.976 135.42 204.083 135.508 204.19C135.149 204.044 134.587 203.647 134.179 204.112C134.519 204.335 135.682 204.946 136.623 205.072C136.885 205.12 137.961 205.082 138.407 205.004C140.385 204.684 144.816 201.872 147.802 197.829C152.95 190.848 153.416 187.94 153.426 186.194C153.464 181.521 147.754 182.297 147.424 185.506Z",
    fill: "url(#paint47_linear)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M151.562 219.363C145.211 222.922 137.115 221.467 140.102 214.273C141.721 210.821 142.37 204.791 142.244 201.184C141.653 199.836 139.762 199.409 138.861 195.851C138.657 193.098 138.618 192.021 139.142 186.611C141.43 183.906 142.497 182.665 145.056 181.657C146.598 181.046 148.605 180.27 150.079 181.172C156.468 185.108 158.504 197.024 157.913 210.424C157.253 214.806 154.694 217.608 151.562 219.363Z",
    fill: "#292929"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M148.683 181.744C147.636 180.687 147.278 178.331 147.161 176.46C147.307 175.432 147.287 174.336 147.045 173.212C146.172 169.178 142.914 166.463 139.754 167.142C136.603 167.821 134.741 171.641 135.614 175.674C136.418 179.407 139.502 181.56 142.401 181.967C142.701 182.549 141.945 183.508 141.528 183.964C143.894 184.682 146.269 183.295 147.471 182.694C148.092 182.384 148.538 182.083 148.683 181.744Z",
    fill: "#FFD3AB"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M129.566 210.085L129.091 210.172C128.694 210.172 128.296 210.395 126.599 209.794C126.124 209.619 125.465 208.999 124.932 208.989C124.35 208.989 123.904 208.95 123.594 208.892C123.894 208.999 124.34 209.096 124.932 209.183C125.455 209.26 126.027 209.978 126.473 210.211C126.745 210.356 126.968 210.453 127.171 210.55L133.493 214.196V214.448L136.479 212.722V212.47L131.234 209.445C130.575 209.794 130.003 210.017 129.566 210.085Z",
    fill: "url(#paint48_linear)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M139.02 187.348C138.768 189.297 138.68 194.562 135.558 200.263C134.569 202.066 131.37 207.602 129.712 208.116C129.469 208.068 129.179 208.01 128.771 207.535C128.199 206.846 127.579 206.391 127.191 206.1C126.793 206.371 127.395 207.108 127.744 207.409C127.744 207.409 127.055 207.186 126.406 206.933C126.066 206.807 124.505 206.672 124.272 206.681C122.857 206.759 122.585 207.108 123.477 207.253C121.975 207.215 122.479 207.709 122.944 207.806C122.43 208.019 122.508 208.359 123.322 208.398C122.663 208.698 123.245 208.979 124.922 208.989C125.455 208.989 126.115 209.619 126.59 209.794C128.287 210.405 128.684 210.172 129.082 210.172L129.557 210.085C131.535 209.765 135.966 206.546 138.952 202.503C144.1 195.522 145.002 189.782 145.021 188.027C145.05 183.363 139.349 184.139 139.02 187.348Z",
    fill: "url(#paint49_linear)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M153.416 184.449C153.61 182.335 151.981 181.56 150.216 179.97C147.434 177.458 149.276 177.866 147.967 173.163C146.658 168.461 142.799 165.028 137.835 166.725C135.324 167.588 133.83 171.68 136.41 174.753C140.123 177.749 137.651 179.931 138.417 180.891C139.231 181.918 139.822 180.842 140.278 182.335C140.734 183.799 138.64 185.06 139.153 186.621C140.133 186.136 142.111 185.39 143.536 187.949C144.554 189.772 141.674 194.552 146.357 193.563C151.04 192.574 151.215 190.994 150.061 189.917C148.907 188.841 152.466 188.366 151.157 186.892C149.848 185.419 153.241 186.311 153.416 184.449Z",
    fill: "#AF7120"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M484.748 312.055H446.867L470.913 325.929L446.867 339.814H484.748L508.784 325.929L484.748 312.055Z",
    fill: "url(#paint50_linear)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M446.869 339.814L470.915 325.929V298.18L446.869 312.055V339.814Z",
    fill: "#CACACB"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M446.87 339.814L422.834 325.929V298.18L446.87 312.055V339.814Z",
    fill: "#F1ECEC"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M446.87 312.055L422.834 298.18L446.87 284.306L470.915 298.18L446.87 312.055Z",
    fill: "#59595B"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M459.707 291.703H442.041L453.249 298.18L442.041 304.647H459.707L470.915 298.18L459.707 291.703Z",
    fill: "url(#paint51_linear)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M442.043 304.647L453.251 298.18V285.236L442.043 291.703V304.647Z",
    fill: "#CACACB"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M442.042 304.647L430.844 298.18V285.236L442.042 291.703V304.647Z",
    fill: "#F1ECEC"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M442.042 291.703L430.844 285.236L442.042 278.76L453.251 285.236L442.042 291.703Z",
    fill: "#59595B"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M485.67 362.23H468.014L479.222 368.707L468.014 375.174H485.67L496.878 368.707L485.67 362.23Z",
    fill: "url(#paint52_linear)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M127.511 467.177H107.848L120.326 474.381L107.848 481.595H127.511L139.999 474.381L127.511 467.177Z",
    fill: "url(#paint53_linear)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M107.848 481.595L120.326 474.381V459.973L107.848 467.177V481.595Z",
    fill: "#CACACB"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M107.847 481.595L95.3594 474.381V459.973L107.847 467.177V481.595Z",
    fill: "#F1ECEC"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M107.847 467.177L95.3594 459.973L107.847 452.759L120.326 459.973L107.847 467.177Z",
    fill: "#59595B"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M470.916 375.562L480.877 369.803V358.302L470.916 364.053V375.562Z",
    fill: "#CACACB"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M470.916 375.562L460.947 369.803V358.302L470.916 364.053V375.562Z",
    fill: "#F1ECEC"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M470.916 364.053L460.947 358.302L470.916 352.544L480.877 358.302L470.916 364.053Z",
    fill: "#59595B"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M177.484 452.963H164.898L172.888 457.578L164.898 462.193H177.484L185.473 457.578L177.484 452.963Z",
    fill: "url(#paint54_linear)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M164.896 462.193L172.886 457.578V448.358L164.896 452.963V462.193Z",
    fill: "#59595B"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M164.896 462.193L156.906 457.578V448.358L164.896 452.963V462.193Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M164.896 452.963L156.906 448.358L164.896 443.742L172.885 448.358L164.896 452.963Z",
    fill: "#292929"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M539.938 203.938H521.826L533.316 210.579L521.826 217.211H539.938L551.427 210.579L539.938 203.938Z",
    fill: "url(#paint55_linear)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M524.688 216.833L533.162 211.938V202.158L524.688 207.043V216.833Z",
    fill: "#59595B"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M524.687 216.833L516.213 211.938V202.158L524.687 207.043V216.833Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M524.687 207.042L516.213 202.158L524.687 197.262L533.161 202.158L524.687 207.042Z",
    fill: "#292929"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M514.736 3.38126L509.103 6.62933C505.816 8.52969 501.288 -1.83505 497.613 0.288317L487.753 5.97971C480.394 10.2264 483.05 -2.13562 472.055 4.2151C459.131 11.6808 460.188 26.6607 452.829 30.9075L442.968 36.5989C439.293 38.7222 438.285 47.5163 434.998 49.4166L429.365 52.6647C428.143 53.3725 425.797 55.331 425.797 57.8907C427.465 56.9211 472.055 31.1886 472.055 31.1886C472.055 31.1886 516.636 5.44645 518.314 4.48657C518.304 1.9269 515.958 2.67347 514.736 3.38126Z",
    fill: "url(#paint56_linear)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M265.877 107.882C265.877 111.052 263.628 114.94 260.894 116.521L173.652 166.89C170.908 168.471 168.668 167.181 168.668 164.011V90.4199C168.668 87.2494 170.908 83.3614 173.652 81.781L260.894 31.4116C263.638 29.8312 265.877 31.1207 265.877 34.2912V107.882Z",
    fill: "url(#paint57_linear)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M179.14 149.816L177.734 150.621V123.298L179.14 122.493V149.816Z",
    fill: "#59595B"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M184.646 134.322L183.24 135.137V112.003L184.646 111.198V134.322Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M189.447 137.367L188.041 138.181V115.726L189.447 114.911V137.367Z",
    fill: "#59595B"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M195.654 144.192L194.248 145.007V129.387L195.654 128.573V144.192Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M201.16 135.34L199.754 136.145V110.044L201.16 109.229V135.34Z",
    fill: "#59595B"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M206.668 124.588L205.262 125.392V98.7484L206.668 97.934V124.588Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M212.173 115.726L210.768 116.54V86.9101L212.173 86.1053V115.726Z",
    fill: "#59595B"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M217.679 131.481L216.273 132.296V91.3119L217.679 90.4974V131.481Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M243.026 81.558C235.589 85.8532 229.559 96.2955 229.559 104.886C229.559 113.476 235.589 116.957 243.026 112.662C250.463 108.367 256.493 97.9244 256.493 89.334L243.026 97.11V81.558Z",
    fill: "#59595B"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M243.025 81.558V97.11L256.493 89.334C256.493 80.7436 250.462 77.2628 243.025 81.558Z",
    fill: "#C0162E"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M178.433 115.328C177.056 116.123 175.941 115.474 175.941 113.893C175.941 112.303 177.056 110.374 178.433 109.579C179.81 108.784 180.925 109.433 180.925 111.014C180.925 112.594 179.81 114.533 178.433 115.328ZM178.433 110.539C177.522 111.062 176.785 112.352 176.785 113.399C176.785 114.456 177.522 114.882 178.433 114.349C179.345 113.825 180.082 112.536 180.082 111.489C180.091 110.442 179.345 110.015 178.433 110.539Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M188.75 95.0157C187.373 95.8108 186.258 95.1611 186.258 93.5807C186.258 91.9906 187.373 90.0612 188.75 89.2661C190.126 88.4711 191.241 89.1207 191.241 90.7011C191.241 92.2815 190.117 94.2207 188.75 95.0157ZM188.75 90.226C187.838 90.7496 187.092 92.0391 187.092 93.0863C187.092 94.1431 187.829 94.5697 188.75 94.0364C189.661 93.5129 190.398 92.2233 190.398 91.1762C190.398 90.1291 189.651 89.7024 188.75 90.226Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M200.464 98.2347C199.088 99.0298 197.973 98.3801 197.973 96.7997C197.973 95.2096 199.088 93.2802 200.464 92.4851C201.841 91.6901 202.956 92.3397 202.956 93.9201C202.956 95.5005 201.841 97.4397 200.464 98.2347ZM200.464 93.445C199.553 93.9686 198.806 95.2581 198.806 96.3052C198.806 97.3621 199.543 97.7887 200.464 97.2554C201.376 96.7319 202.113 95.4423 202.113 94.3952C202.113 93.348 201.376 92.9215 200.464 93.445Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M211.476 74.2862C210.099 75.0813 208.984 74.4316 208.984 72.8512C208.984 71.2611 210.099 69.3317 211.476 68.5366C212.853 67.7416 213.968 68.3912 213.968 69.9716C213.968 71.5617 212.843 73.4912 211.476 74.2862ZM211.476 69.5062C210.565 70.0298 209.828 71.3193 209.828 72.3664C209.828 73.4233 210.565 73.8499 211.476 73.3166C212.388 72.7931 213.124 71.5035 213.124 70.4564C213.124 69.4093 212.388 68.9729 211.476 69.5062Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M224.052 84.4377C222.676 85.2327 221.561 84.5831 221.561 83.0027C221.561 81.4126 222.676 79.4832 224.052 78.6881C225.429 77.8931 226.544 78.5427 226.544 80.1231C226.544 81.7035 225.429 83.6426 224.052 84.4377ZM224.052 79.648C223.141 80.1716 222.404 81.4611 222.404 82.5083C222.404 83.5651 223.141 83.9917 224.052 83.4584C224.964 82.9348 225.701 81.6453 225.701 80.5982C225.71 79.5511 224.964 79.1244 224.052 79.648Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M232.904 67.858C231.527 68.653 230.412 68.0034 230.412 66.423C230.412 64.8329 231.527 62.9035 232.904 62.1084C234.281 61.3134 235.396 61.963 235.396 63.5434C235.396 65.1238 234.271 67.0629 232.904 67.858ZM232.904 63.0683C231.993 63.5919 231.256 64.8814 231.256 65.9285C231.256 66.9854 231.993 67.412 232.904 66.8787C233.815 66.3552 234.552 65.0656 234.552 64.0185C234.552 62.9713 233.815 62.5447 232.904 63.0683Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M231.112 67.3352L225.018 78.7654L225.873 79.2216L231.968 67.7914L231.112 67.3352Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M213.095 72.0697L212.486 72.8245L222.418 80.8349L223.027 80.0802L213.095 72.0697Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M209.82 73.8529L201.23 92.5162L202.111 92.9216L210.701 74.2583L209.82 73.8529Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M190.507 92.1133L190.25 93.0482L198.637 95.3512L198.893 94.4162L190.507 92.1133Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M186.983 94.4721L179.324 109.592L180.189 110.03L187.848 94.9103L186.983 94.4721Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M260.74 42.6877L250.938 48.3403V45.4316L260.74 39.7789V42.6877Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M260.74 48.1464L255.01 51.4526V48.5439L260.74 45.2377V48.1464Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M360.109 243.552C360.109 245.659 358.576 248.277 356.788 249.363L302.322 280.779C300.471 281.865 299.002 280.971 299.002 278.863V229.44C299.002 227.333 300.534 224.715 302.322 223.629L356.788 192.213C358.64 191.127 360.109 192.021 360.109 194.129V243.552Z",
    fill: "url(#paint58_linear)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M298.938 278.863V229.44C298.938 227.333 300.47 224.715 302.258 223.629L356.724 192.213C357.618 191.702 358.448 191.638 359.087 191.957L357.235 190.872C356.596 190.489 355.766 190.553 354.872 191.063L300.406 222.48C298.555 223.565 297.086 226.183 297.086 228.291V277.714C297.086 278.799 297.469 279.566 298.108 279.885L299.895 280.907C299.257 280.651 298.938 279.885 298.938 278.863Z",
    fill: "#292929"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M307.367 246.298L304.877 247.702V244.829L307.367 243.36V246.298Z",
    fill: "#292929"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M312.665 243.232L310.111 244.701V241.764L312.665 240.295V243.232Z",
    fill: "#292929"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M317.966 240.167L315.412 241.636V238.699L317.966 237.23V240.167Z",
    fill: "#292929"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M323.267 237.102L320.713 238.571V235.634L323.267 234.165V237.102Z",
    fill: "#292929"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M328.568 234.037L326.014 235.506V232.569L328.568 231.1V234.037Z",
    fill: "#C0162E"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M333.869 230.972L331.314 232.441V229.504L333.869 228.035V230.972Z",
    fill: "#59595B"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M339.165 227.907L336.611 229.376V226.439L339.165 225.034V227.907Z",
    fill: "#59595B"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M307.367 252.364L304.877 253.832V250.895L307.367 249.49V252.364Z",
    fill: "#C0162E"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M312.665 249.299L310.111 250.767V247.894L312.665 246.425V249.299Z",
    fill: "#C0162E"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M317.966 246.298L315.412 247.702V244.829L317.966 243.36V246.298Z",
    fill: "#C0162E"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M323.267 243.232L320.713 244.701V241.764L323.267 240.295V243.232Z",
    fill: "#C0162E"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M328.568 240.167L326.014 241.636V238.699L328.568 237.23V240.167Z",
    fill: "#C0162E"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M333.869 237.102L331.314 238.571V235.634L333.869 234.165V237.102Z",
    fill: "#59595B"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M339.165 234.037L336.611 235.506V232.569L339.165 231.1V234.037Z",
    fill: "#59595B"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M307.367 258.494L304.877 259.962V257.025L307.367 255.556V258.494Z",
    fill: "#C0162E"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M312.665 255.429L310.111 256.897V253.96L312.665 252.491V255.429Z",
    fill: "#C0162E"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M317.966 252.364L315.412 253.832V250.895L317.966 249.49V252.364Z",
    fill: "#C0162E"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M323.267 249.299L320.713 250.767V247.894L323.267 246.425V249.299Z",
    fill: "#C0162E"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M328.568 246.298L326.014 247.702V244.829L328.568 243.36V246.298Z",
    fill: "#C0162E"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M333.869 243.232L331.314 244.701V241.764L333.869 240.295V243.232Z",
    fill: "#59595B"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M339.165 240.167L336.611 241.636V238.699L339.165 237.23V240.167Z",
    fill: "#59595B"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M307.367 264.624L304.877 266.092V263.155L307.367 261.686V264.624Z",
    fill: "#C0162E"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M312.665 261.559L310.111 263.027V260.09L312.665 258.621V261.559Z",
    fill: "#C0162E"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M317.966 258.494L315.412 259.962V257.025L317.966 255.556V258.494Z",
    fill: "#C0162E"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M323.267 255.429L320.713 256.897V253.96L323.267 252.491V255.429Z",
    fill: "#C0162E"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M328.568 252.364L326.014 253.832V250.895L328.568 249.49V252.364Z",
    fill: "#C0162E"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M333.869 249.299L331.314 250.767V247.894L333.869 246.425V249.299Z",
    fill: "#59595B"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M339.165 246.298L336.611 247.702V244.829L339.165 243.36V246.298Z",
    fill: "#59595B"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M307.367 270.754L304.877 272.159V269.285L307.367 267.817V270.754Z",
    fill: "#C0162E"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M312.665 267.689L310.111 269.157V266.22L312.665 264.751V267.689Z",
    fill: "#C0162E"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M317.966 264.624L315.412 266.092V263.155L317.966 261.686V264.624Z",
    fill: "#C0162E"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M323.267 261.559L320.713 263.027V260.09L323.267 258.621V261.559Z",
    fill: "#C0162E"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M328.568 258.494L326.014 259.962V257.025L328.568 255.556V258.494Z",
    fill: "#292929"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M333.869 255.429L331.314 256.897V253.96L333.869 252.491V255.429Z",
    fill: "#292929"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M339.165 252.364L336.611 253.832V250.895L339.165 249.49V252.364Z",
    fill: "#292929"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M317.967 223.757L304.877 231.356V235.059L317.967 227.461V223.757Z",
    fill: "#C0162E"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M355.194 229.695L344.658 235.825V240.359L355.194 234.229V229.695Z",
    fill: "#C0162E"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M355.194 237.613L344.658 243.743V248.277L355.194 242.147V237.613Z",
    fill: "#C0162E"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M353.277 211.433C353.596 211.88 353.724 212.519 353.724 213.285C353.724 215.711 352 218.649 349.893 219.862C347.786 221.075 346.062 220.117 346.062 217.691C346.062 215.264 347.786 212.327 349.893 211.114V208.368C346.509 210.348 343.699 215.137 343.699 219.032C343.699 222.991 346.445 224.587 349.893 222.608C353.277 220.628 356.087 215.839 356.087 211.944C356.087 210.731 355.831 209.709 355.32 208.943L353.277 211.433Z",
    fill: "#59595B"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M353.277 211.433L355.384 208.943C354.363 207.346 352.32 207.027 349.957 208.368V211.114C351.362 210.22 352.639 210.412 353.277 211.433Z",
    fill: "#C0162E"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M379.012 316.495H347.883V322.216H379.012V316.495Z",
    fill: "url(#paint59_linear)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M393.072 308.251H361.943V313.973H393.072V308.251Z",
    fill: "url(#paint60_linear)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M365.437 312.227C365.437 307.767 362.625 307.573 362.625 307.573C362.625 307.573 361.073 307.573 358.552 306.506C356.127 305.439 352.636 305.924 354.576 309.512C354.576 309.512 354.576 309.609 354.673 309.609C354.77 309.803 354.964 309.997 355.352 310.191L361.558 313.876C362.334 314.361 365.34 313.1 365.437 312.227Z",
    fill: "#AE2C34"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M365.34 311.742C365.243 312.712 362.334 313.876 361.364 313.391L355.158 309.706C354.964 309.609 354.576 309.318 354.285 309.027C354.382 309.124 354.382 309.221 354.479 309.415C354.479 309.415 354.479 309.512 354.576 309.512C354.673 309.706 354.867 309.9 355.255 310.094L361.461 313.779C362.334 314.264 365.049 313.197 365.437 312.324C365.437 312.227 365.437 312.227 365.437 312.13C365.437 312.033 365.34 311.936 365.34 311.742Z",
    fill: "url(#paint61_linear)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M364.273 306.991C363.497 306.991 360.975 307.67 360.975 307.67C360.975 307.67 360.975 308.058 360.781 308.349C360.781 308.349 360.782 308.446 360.685 308.446C360.2 308.833 359.618 309.318 360.878 310.094C361.848 310.676 362.624 310.288 363.012 309.9C363.206 309.609 363.4 309.318 363.691 309.124C363.982 308.93 364.176 308.833 364.37 308.833V308.737C364.37 308.737 364.564 306.991 364.273 306.991Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M364.271 263.061C361.459 263.158 354.476 263.255 351.664 263.255C352.731 271.692 354.767 279.353 356.222 287.596C357.774 295.548 359.422 301.172 360.877 307.767C361.459 309.027 363.883 308.542 364.368 307.379C364.756 301.269 365.241 293.899 363.398 286.82C363.786 279.159 364.465 270.722 364.271 263.061Z",
    fill: "black"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M351.179 320.47C351.179 316.009 348.367 315.815 348.367 315.815C348.367 315.815 346.815 315.815 344.294 314.749C341.87 313.682 338.379 314.167 340.318 317.755C340.318 317.755 340.318 317.852 340.415 317.852C340.512 318.046 340.706 318.24 341.094 318.434L347.3 322.119C348.173 322.604 351.179 321.343 351.179 320.47Z",
    fill: "#AE2C34"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M351.18 320.082C351.083 321.052 348.174 322.216 347.204 321.731L340.998 318.046C340.804 317.949 340.416 317.658 340.125 317.367C340.222 317.464 340.222 317.561 340.319 317.755C340.319 317.755 340.319 317.852 340.416 317.852C340.513 318.046 340.707 318.24 341.095 318.434L347.301 322.119C348.174 322.604 350.889 321.537 351.277 320.664C351.277 320.567 351.277 320.567 351.277 320.47C351.18 320.276 351.18 320.179 351.18 320.082Z",
    fill: "url(#paint62_linear)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M350.017 315.234C349.241 315.234 346.72 315.913 346.72 315.913C346.72 315.913 346.72 316.301 346.526 316.592C346.526 316.592 346.526 316.689 346.429 316.689C345.944 317.077 345.362 317.561 346.623 318.337C347.592 318.919 348.368 318.531 348.756 318.143C348.95 317.852 349.144 317.561 349.435 317.367C349.726 317.173 349.92 317.077 350.114 317.077V316.98C350.114 316.98 350.405 315.234 350.017 315.234Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M355.349 283.135C356.125 279.547 364.95 279.062 364.368 264.807C361.556 264.419 347.591 271.013 344.779 270.528C344.391 279.062 345.264 286.917 345.264 295.257C345.458 303.306 346.234 309.124 346.622 315.913C346.913 317.173 349.531 317.173 350.21 316.107C351.567 310.191 353.216 302.918 352.634 295.645C353.507 291.669 354.477 287.402 355.349 283.135Z",
    fill: "black"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M357.967 238.817C367.858 245.411 369.022 258.6 363.688 266.94C363.688 266.94 364.852 248.418 357.967 238.817Z",
    fill: "url(#paint63_linear)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M359.228 293.414C353.215 296.808 343.906 294.287 341.578 289.438C342.354 281.68 345.554 258.115 344.003 250.648C344.487 246.575 344.875 246.575 344.293 244.151C346.718 241.533 350.985 236.102 352.924 235.714C359.325 234.356 363.204 243.084 364.27 254.333C364.561 257.533 365.531 280.032 365.434 283.426C365.337 288.275 362.137 291.766 359.228 293.414Z",
    fill: "url(#paint64_linear)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M357.481 236.684C355.735 235.423 355.929 234.55 356.22 232.805C356.608 231.932 356.802 230.865 356.802 229.799C356.802 225.92 354.281 222.526 351.274 222.719C345.165 223.107 346.232 226.405 346.232 230.284C346.232 233.872 347.88 236.393 350.595 236.781C350.595 237.363 349.141 238.623 348.559 239.496C351.565 241.824 354.668 239.108 355.832 238.623C356.996 238.042 358.354 237.557 357.481 236.684Z",
    fill: "#F6D3AF"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M353.897 223.01C353.121 222.622 352.346 222.816 351.958 222.525C350.891 221.847 349.921 221.459 349.339 221.75C349.049 221.944 348.564 222.331 348.564 222.331C347.982 222.913 346.915 221.75 346.624 223.107C346.527 223.495 346.527 223.883 346.527 224.174C343.909 224.465 345.17 226.889 347.303 231.544C347.303 230.768 348.855 229.023 348.855 232.417C348.855 232.805 348.564 232.805 348.855 233.29C349.049 233.775 350.6 234.938 351.57 235.908C352.928 237.266 354.285 235.52 356.613 235.811C356.322 235.326 356.322 234.841 356.71 234.259C356.904 233.872 358.164 232.611 358.164 230.477C356.419 230.768 359.619 225.92 353.897 223.01Z",
    fill: "#AF7120"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M325.385 255.885C326.936 254.624 329.652 254.237 331.494 254.915C333.24 255.497 333.434 256.176 334.113 256.952C333.628 257.437 334.016 258.116 332.173 258.503C331.3 258.213 330.428 258.988 329.07 257.631C327.712 256.273 327.809 255.885 327.809 255.885C324.997 256.661 324.997 256.273 325.385 255.885Z",
    fill: "#F4D1AD"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M346.332 242.696C343.132 242.114 342.453 252.394 342.453 259.085C340.901 258.406 335.858 256.952 333.531 256.176C331.592 256.176 330.816 257.437 332.173 259.279C335.083 261.219 342.744 266.552 346.138 265.388C349.532 264.225 349.532 255.788 349.823 251.618C350.211 247.545 350.211 243.375 346.332 242.696Z",
    fill: "url(#paint65_linear)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 282.543,
    y: 412.324,
    width: 78.4149,
    height: 45.2408,
    fill: "url(#pattern0)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M290.791 417.592C289.333 416.738 289.333 415.33 290.791 414.526L331.204 391.202C332.662 390.347 335.075 390.347 336.583 391.202L355.03 401.859C356.488 402.713 356.488 404.121 355.03 404.925L314.566 428.249C313.109 429.104 310.696 429.104 309.188 428.249L290.791 417.592Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M332.207 397.786L333.966 396.781L332.207 395.776L330.498 396.781L332.207 397.786Z",
    fill: "#292929"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M329.293 399.445L331.052 398.44L329.293 397.435L327.584 398.44L329.293 399.445Z",
    fill: "#292929"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M326.377 401.104L328.136 400.149L326.377 399.144L324.668 400.149L326.377 401.104Z",
    fill: "#292929"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M323.515 402.813L325.224 401.808L323.515 400.802L321.756 401.808L323.515 402.813Z",
    fill: "#292929"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M320.595 404.472L322.304 403.467L320.595 402.511L318.836 403.467L320.595 404.472Z",
    fill: "#292929"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M317.683 406.181L319.392 405.176L317.683 404.171L315.924 405.176L317.683 406.181Z",
    fill: "#292929"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M314.768 407.84L316.477 406.835L314.768 405.829L313.059 406.835L314.768 407.84Z",
    fill: "#292929"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 409.499L313.561 408.544L311.852 407.538L310.143 408.544L311.852 409.499Z",
    fill: "#292929"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M308.938 411.208L310.647 410.202L308.938 409.197L307.229 410.202L308.938 411.208Z",
    fill: "#292929"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M306.02 412.867L307.779 411.861L306.02 410.906L304.311 411.861L306.02 412.867Z",
    fill: "#292929"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M303.106 414.576L304.865 413.57L303.106 412.565L301.396 413.57L303.106 414.576Z",
    fill: "#292929"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M300.19 416.235L301.949 415.229L300.19 414.224L298.48 415.229L300.19 416.235Z",
    fill: "#292929"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M333.767 400.25L336.833 398.44L335.124 397.435L332.008 399.244L333.767 400.25Z",
    fill: "#292929"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M335.377 402.512L339.649 400.048L337.89 399.043L333.617 401.556L335.377 402.512Z",
    fill: "#292929"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M337.086 404.874L342.565 401.757L340.806 400.752L335.377 403.919L337.086 404.874Z",
    fill: "#292929"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M342.966 405.578L346.083 403.768L343.72 402.411L340.604 404.221L342.966 405.578Z",
    fill: "#292929"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M338.693 408.041L341.759 406.231L339.447 404.874L336.33 406.684L338.693 408.041Z",
    fill: "#292929"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M334.369 410.504L337.485 408.745L335.173 407.387L332.057 409.147L334.369 410.504Z",
    fill: "#292929"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M319.592 419.05L322.708 417.24L320.396 415.883L317.279 417.692L319.592 419.05Z",
    fill: "#292929"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M312.355 423.222L318.437 419.703L316.074 418.396L309.992 421.915L312.355 423.222Z",
    fill: "#292929"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M323.865 416.587L333.214 411.208L330.852 409.851L321.553 415.229L323.865 416.587Z",
    fill: "#292929"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M330.046 402.411L332.56 400.903L330.851 399.948L328.287 401.406L330.046 402.411Z",
    fill: "#292929"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M331.606 404.673L334.169 403.215L332.46 402.21L329.896 403.668L331.606 404.673Z",
    fill: "#292929"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M333.266 406.985L335.829 405.527L334.07 404.522L331.557 405.98L333.266 406.985Z",
    fill: "#292929"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M329.543 409.147L332.107 407.689L330.347 406.684L327.834 408.141L329.543 409.147Z",
    fill: "#292929"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M325.824 411.308L328.388 409.851L326.629 408.845L324.115 410.303L325.824 411.308Z",
    fill: "#292929"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M322.104 413.47L324.667 411.962L322.908 411.007L320.395 412.465L322.104 413.47Z",
    fill: "#292929"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M318.387 415.581L320.95 414.123L319.191 413.118L316.678 414.576L318.387 415.581Z",
    fill: "#292929"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M314.668 417.743L317.181 416.285L315.472 415.28L312.959 416.737L314.668 417.743Z",
    fill: "#292929"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M308.734 421.161L313.459 418.446L311.75 417.441L307.025 420.155L308.734 421.161Z",
    fill: "#292929"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M327.889 406.835L330.452 405.377L328.743 404.372L326.18 405.829L327.889 406.835Z",
    fill: "#292929"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M324.164 408.996L326.728 407.538L325.019 406.533L322.455 407.991L324.164 408.996Z",
    fill: "#292929"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M320.447 411.108L323.011 409.65L321.252 408.644L318.738 410.152L320.447 411.108Z",
    fill: "#292929"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M316.727 413.269L319.29 411.811L317.531 410.806L315.018 412.264L316.727 413.269Z",
    fill: "#292929"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M313.006 415.431L315.569 413.973L313.81 412.968L311.297 414.425L313.006 415.431Z",
    fill: "#292929"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M305.919 419.552L311.851 416.134L310.092 415.129L304.16 418.547L305.919 419.552Z",
    fill: "#292929"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M326.275 404.522L328.839 403.064L327.13 402.059L324.566 403.517L326.275 404.522Z",
    fill: "#292929"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M322.559 406.684L325.122 405.226L323.413 404.22L320.85 405.678L322.559 406.684Z",
    fill: "#292929"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M318.838 408.845L321.402 407.387L319.692 406.382L317.129 407.84L318.838 408.845Z",
    fill: "#292929"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M315.119 411.007L317.683 409.499L315.923 408.543L313.41 410.001L315.119 411.007Z",
    fill: "#292929"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M311.399 413.118L313.962 411.66L312.203 410.655L309.689 412.163L311.399 413.118Z",
    fill: "#292929"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M307.68 415.279L310.243 413.822L308.484 412.816L305.971 414.274L307.68 415.279Z",
    fill: "#292929"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M303.106 417.944L306.524 415.983L304.764 414.978L301.396 416.938L303.106 417.944Z",
    fill: "#292929"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M354.98 404.925L314.567 428.249C313.109 429.103 310.696 429.103 309.188 428.249L290.741 417.592C289.987 417.19 289.635 416.587 289.635 416.034V417.19C289.635 417.743 289.987 418.296 290.741 418.748L309.188 429.405C310.646 430.259 313.059 430.259 314.567 429.405L354.98 406.081C355.734 405.628 356.086 405.075 356.086 404.522V403.366C356.086 403.919 355.684 404.472 354.98 404.925Z",
    fill: "#BDC1E4"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M288.123 377.78C288.123 376.071 289.329 374.01 290.787 373.156L331.201 349.832C332.659 348.977 333.865 349.681 333.865 351.39V386.527C333.865 388.236 332.659 390.297 331.201 391.152L290.787 414.476C289.329 415.33 288.123 414.626 288.123 412.917V377.78Z",
    fill: "url(#paint66_linear)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M290.789 414.526L331.202 391.202C332.66 390.347 333.867 388.286 333.867 386.577V354.155C330.247 356.266 331.806 365.616 329.041 367.174C327.131 368.28 326.678 363.253 323.813 364.862C320.848 366.571 319.641 380.696 316.324 382.656C313.66 384.215 313.257 379.791 310.593 381.299C307.024 383.36 307.075 393.062 303.606 395.072C299.987 397.184 297.122 383.461 293.704 385.421C291.794 386.527 289.532 393.665 288.074 397.586V413.018C288.124 414.677 289.331 415.38 290.789 414.526Z",
    fill: "url(#paint67_linear)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M311.094 400.35L310.189 400.903V381.5L311.094 380.997V400.35Z",
    fill: "#292929"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M311.486 381.747C311.972 380.906 311.976 379.998 311.495 379.721C311.014 379.443 310.231 379.9 309.745 380.742C309.259 381.583 309.255 382.49 309.736 382.768C310.217 383.046 311 382.589 311.486 381.747Z",
    fill: "#292929"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M297.372 373.91L292.346 376.775V374.865L297.372 371.949V373.91Z",
    fill: "#C0162E"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M296.92 376.675L292.346 379.339V378.082L296.92 375.468V376.675Z",
    fill: "#C0162E"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M288.123 412.968V377.831C288.123 376.121 289.33 374.061 290.787 373.206L331.201 349.882C331.905 349.48 332.609 349.429 333.061 349.681L331.654 348.876C331.151 348.575 330.497 348.575 329.693 349.027L289.279 372.351C287.822 373.206 286.615 375.267 286.615 376.976V412.113C286.615 413.018 286.967 413.621 287.47 413.872L288.827 414.626C288.375 414.325 288.123 413.772 288.123 412.968Z",
    fill: "#292929"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M339.046 452.981C339.046 448.658 336.281 448.507 336.281 448.507C336.281 448.507 334.773 448.507 332.36 447.501C329.998 446.496 326.63 446.898 328.49 450.367C328.49 450.417 328.54 450.467 328.54 450.517C328.64 450.719 328.842 450.869 329.143 451.07L335.125 454.589C336.13 455.092 339.046 453.885 339.046 452.981Z",
    fill: "url(#paint68_linear)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M339.045 452.578C338.995 453.483 336.13 454.639 335.225 454.136L329.243 450.618C329.042 450.517 328.69 450.266 328.389 450.014C328.439 450.115 328.489 450.266 328.539 450.366C328.539 450.417 328.59 450.467 328.59 450.517C328.69 450.718 328.891 450.869 329.193 451.07L335.175 454.589C336.029 455.091 338.643 454.036 338.995 453.181C338.995 453.131 339.045 453.03 339.045 453.03C339.045 452.829 339.045 452.729 339.045 452.578Z",
    fill: "black"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M337.938 447.954C337.235 447.954 334.772 448.607 334.772 448.607C334.772 448.607 334.772 448.959 334.57 449.261C334.52 449.311 334.52 449.311 334.52 449.361C334.018 449.713 333.515 450.266 334.671 450.97C335.626 451.573 336.38 451.171 336.782 450.819C336.933 450.517 337.134 450.216 337.436 450.065C337.737 449.864 337.938 449.814 338.089 449.814V449.763C338.089 449.763 338.24 447.954 337.938 447.954Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M361.314 441.57C360.208 437.548 359.706 433.275 358.6 428.55C355.986 428.048 335.277 417.944 332.462 423.373C332.361 423.574 332.311 423.775 332.311 424.026C331.305 429.053 334.623 448.808 334.623 448.808C334.673 449.009 334.824 449.21 335.075 449.361C335.729 449.713 336.784 449.713 337.438 449.361C337.74 449.21 337.991 448.959 337.991 448.758C337.991 448.758 339.449 436.995 338.996 431.818C346.184 437.347 356.991 443.027 361.314 441.57Z",
    fill: "black"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M330.547 458.811C330.547 454.488 327.783 454.337 327.783 454.337C327.783 454.337 326.275 454.337 323.862 453.332C321.5 452.327 318.132 452.729 319.992 456.197C319.992 456.248 320.042 456.298 320.042 456.348C320.142 456.549 320.344 456.7 320.645 456.901L326.627 460.42C327.582 460.872 330.497 459.666 330.547 458.811Z",
    fill: "#C0162E"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M330.498 458.409C330.448 459.314 327.583 460.47 326.678 459.968L320.696 456.449C320.495 456.348 320.143 456.097 319.842 455.846C319.892 455.946 319.942 456.097 319.993 456.197C319.993 456.248 320.043 456.298 320.043 456.348C320.143 456.549 320.344 456.7 320.646 456.901L326.628 460.42C327.482 460.923 330.096 459.867 330.448 459.012C330.448 458.962 330.498 458.862 330.498 458.862C330.548 458.661 330.498 458.56 330.498 458.409Z",
    fill: "#20196F"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M329.391 453.785C328.687 453.785 326.174 454.438 326.174 454.438C326.174 454.438 326.174 454.79 325.973 455.092C325.923 455.142 325.923 455.142 325.923 455.192C325.42 455.544 324.917 456.097 326.073 456.801C327.028 457.404 327.782 457.002 328.185 456.65C328.335 456.348 328.536 456.047 328.838 455.896C329.14 455.695 329.341 455.644 329.491 455.644V455.594C329.491 455.594 329.692 453.785 329.391 453.785Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M323.813 429.857C322.807 434.884 326.125 454.639 326.125 454.639C326.175 454.84 326.326 455.041 326.577 455.192C327.231 455.544 328.286 455.544 328.94 455.192C329.241 455.041 329.493 454.79 329.493 454.589C329.493 454.589 330.951 442.826 330.498 437.649C328.136 435.839 323.813 432.924 323.813 429.857Z",
    fill: "#292929"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M389.508 449.06H358.242L388.904 466.754L358.242 484.448H389.508L420.12 466.754L389.508 449.06Z",
    fill: "url(#paint69_linear)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M358.242 484.448L388.904 466.754V443.882L358.242 461.576V484.448Z",
    fill: "#59595B"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M358.242 484.448L327.58 466.754V443.882L358.242 461.576V484.448Z",
    fill: "#E0E0E0"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M358.242 461.576L327.58 443.882L358.242 426.188L388.905 443.882L358.242 461.576Z",
    fill: "#BDBDBD"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M343.112 412.917C342.409 412.314 342.509 412.414 341.705 411.811C341.655 411.66 341.655 411.509 341.604 411.358C341.403 411.258 341.202 411.208 341.102 411.208C340.499 411.258 339.996 411.208 339.644 411.107C339.091 410.956 337.935 407.789 335.221 407.94C335.975 408.543 336.98 409.8 336.779 409.7C336.779 409.7 336.176 409.247 335.522 409.8C335.975 410.152 337.483 411.208 338.739 411.509C339.091 411.61 339.544 411.66 340.197 411.61C340.298 411.61 340.448 411.66 340.7 411.761C340.7 411.911 340.7 412.062 340.8 412.213C341.454 412.716 341.956 413.168 342.258 413.419C342.409 413.319 342.962 413.017 343.112 412.917Z",
    fill: "url(#paint70_linear)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M328.938 416.687C328.888 416.586 328.888 416.436 328.888 416.335C326.325 416.486 325.621 414.777 324.867 413.972C324.063 413.168 323.912 412.917 323.057 412.917C322.203 412.917 321.499 412.213 322.354 411.71C322.555 411.56 322.806 411.459 323.007 411.359C322.957 411.359 322.907 411.409 322.856 411.409C322.655 411.509 322.002 411.761 321.499 412.113C320.645 412.615 321.348 413.319 322.203 413.319C323.057 413.319 323.258 413.57 324.012 414.375C324.766 415.179 325.47 416.888 328.034 416.737C328.034 416.838 328.084 416.988 328.084 417.089C329.642 418.295 329.994 418.748 331.301 419.753L332.206 419.251C330.949 418.195 330.497 417.843 328.938 416.687Z",
    fill: "url(#paint71_linear)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M349.597 417.139C350.351 417.29 351.206 417.391 352.111 417.29C352.312 417.29 352.513 417.24 352.714 417.19C352.261 417.491 351.759 417.642 351.206 417.692C350.402 417.742 349.698 417.692 348.994 417.592C349.245 417.441 349.447 417.29 349.597 417.139Z",
    fill: "url(#paint72_linear)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M350.102 434.381C347.488 433.878 326.778 423.775 323.963 429.203C323.863 429.405 323.812 429.606 323.812 429.857C323.812 432.923 328.135 435.839 330.548 437.648C337.686 443.178 348.493 448.858 352.816 447.4C359.803 445.088 363.271 443.228 365.533 438.503C366.287 436.945 366.438 432.571 366.438 430.712C358.647 426.891 352.615 430.36 350.102 434.381Z",
    fill: "#292929"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M335.424 406.985C335.927 406.683 336.58 406.382 336.781 406.281C337.636 405.879 339.043 406.181 339.445 406.482C339.847 406.734 342.21 408.242 342.662 409.197C342.662 409.197 343.567 409.649 343.919 409.85L342.612 411.861C342.612 411.861 341.456 411.258 341.205 411.258C340.601 411.308 340.099 411.258 339.747 411.157C338.44 410.805 336.932 409.8 336.53 409.448C337.183 408.845 337.887 409.498 338.339 409.75C338.239 409.599 338.138 409.448 337.988 409.297C337.183 408.493 337.033 408.242 336.178 408.242C335.223 408.192 334.57 407.488 335.424 406.985Z",
    fill: "#FCD1A9"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M341.707 411.811C341.255 410.454 342.863 409.197 343.869 409.298C348.393 411.258 350.604 412.465 352.112 411.962C358.597 408.946 355.983 416.939 352.112 417.24C347.588 417.693 345.326 414.626 341.707 411.811Z",
    fill: "black"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M360.555 401.657C363.822 402.361 367.944 404.472 365.179 410.152C363.319 414.073 360.555 401.657 360.555 401.657Z",
    fill: "black"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M359.952 439.76C353.568 443.379 344.822 442.022 343.666 436.995C348.039 422.367 348.994 412.616 348.894 406.684C351.709 404.522 354.121 402.562 356.182 402.11C358.344 401.607 361.209 401.255 362.465 402.462C366.386 407.79 365.381 416.939 366.336 430.762C365.682 435.135 363.069 437.95 359.952 439.76Z",
    fill: "black"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M359.147 401.909C358.041 400.903 357.74 399.194 357.539 397.334C357.639 396.279 357.589 395.173 357.287 394.067C356.282 390.046 352.864 387.432 349.697 388.186C346.531 388.99 344.822 392.911 345.827 396.932C346.782 400.652 350.049 402.713 353.015 403.065C353.166 403.366 352.613 403.819 352.11 404.171C354.523 404.824 356.785 403.568 357.941 402.914C358.594 402.562 358.997 402.261 359.147 401.909Z",
    fill: "#FCD1A9"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M330.951 414.375C330.6 414.174 330.047 413.872 330.047 413.872C330.047 413.671 329.343 411.409 327.383 410.856C326.98 411.459 327.684 411.962 328.237 412.515C327.584 411.962 326.679 411.459 326.327 411.158C325.925 410.906 324.568 410.554 323.663 410.957C323.462 411.057 322.808 411.308 322.306 411.66C321.451 412.163 322.155 412.867 323.009 412.867C323.864 412.867 324.065 413.118 324.819 413.922C325.623 414.727 326.277 416.436 328.891 416.285C329.142 416.285 329.494 416.486 329.494 416.486L330.951 414.375Z",
    fill: "#FCD1A9"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M328.94 416.687C328.487 415.33 330.096 414.073 331.101 414.174C335.625 416.134 337.837 417.34 339.345 416.838C345.829 413.822 347.237 408.141 348.845 406.633C352.464 404.07 356.837 409.75 352.062 414.928C347.036 419.653 343.165 421.814 339.295 422.166C334.871 422.568 332.559 419.452 328.94 416.687Z",
    fill: "black"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M358.143 393.313C358.143 393.262 358.143 393.262 358.143 393.313C357.49 391.302 356.484 389.542 354.775 388.437C350.352 385.521 348.542 385.772 348.14 386.476C343.415 385.923 342.36 388.437 345.577 392.006C346.482 393.212 346.079 396.63 347.738 397.133C347.537 396.379 348.744 394.167 349.598 397.585C349.699 397.937 349.447 398.088 349.799 398.54C350.151 398.943 352.011 399.797 353.318 400.551C355.127 401.607 355.63 400.099 358.043 399.797C357.791 398.792 357.942 398.189 358.143 397.485C358.294 396.982 358.495 395.172 358.143 393.313Z",
    fill: "#FFCF6E"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4893 411.167C92.2072 410.603 91.8312 410.133 91.3611 409.569C89.8568 408.064 93.3355 405.526 94.9338 404.586L90.3269 401.859H76.6C75.6598 400.731 75.4718 399.132 75.4718 398.286H68.8904C68.8904 399.32 68.4203 401.765 66.634 402.799C66.2579 402.987 65.7878 403.175 65.3177 403.269C64.3775 403.457 63.4373 403.645 62.5912 403.927C62.4971 403.927 62.4971 403.927 62.4971 403.927C61.651 403.645 60.7108 403.457 59.7706 403.269C56.856 402.799 56.1978 399.603 56.1978 398.286H49.6165C49.6165 399.32 49.1464 401.765 47.36 402.799C46.9839 402.987 46.5139 403.175 46.0438 403.269C45.1036 403.457 44.1634 403.645 43.3172 403.927C40.3086 404.586 36.2657 402.799 34.7614 401.859L30.0605 404.586C31.6588 405.526 35.1375 408.064 33.6332 409.569C33.1631 410.039 32.787 410.603 32.505 411.167C32.411 411.449 32.1289 411.731 31.7528 411.919C29.9664 412.953 25.8296 413.235 23.9492 413.235V417.09C26.2057 417.09 31.7528 417.466 32.505 419.159C32.787 419.723 33.1631 420.193 33.6332 420.757C35.1375 422.261 31.6588 424.8 30.0605 425.74L34.6674 428.466C34.8555 428.372 35.0435 428.278 35.2315 428.184L34.6674 428.466H48.3942C49.3344 429.595 49.5225 431.193 49.5225 432.039H75.3778L81.8651 428.466H90.3269L95.0278 425.74C93.4295 424.8 89.9508 422.261 91.4551 420.757C91.7371 420.475 91.9252 420.099 92.2073 419.817H96.5321L101.233 417.09V413.235C98.6006 413.329 93.2414 412.859 92.4893 411.167Z",
    fill: "url(#paint73_linear)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8219 397.534C33.8219 396.029 31.1893 394.149 29.873 393.397V404.491C31.1893 405.243 33.8219 407.124 33.8219 408.628V397.534Z",
    fill: "#CACACB"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6598 404.585V393.491C74.3435 394.243 71.7109 396.124 71.7109 397.628V408.722C71.7109 407.218 74.3435 405.337 75.6598 404.585Z",
    fill: "#CACACB"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5392 410.321C49.1462 407.688 56.4797 407.688 61.0867 410.321C63.3431 411.637 64.4714 413.329 64.4714 415.022V403.927C64.4714 402.235 63.3431 400.449 61.0867 399.132C56.5737 396.5 49.1462 396.5 44.5392 399.132C42.2828 400.449 41.0605 402.235 41.0605 403.927V415.022C41.0605 413.423 42.1888 411.637 44.5392 410.321Z",
    fill: "url(#paint74_linear)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4764 417.184L29.7754 414.551V425.645L34.4764 428.372V417.184Z",
    fill: "#CACACB"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5662 425.645L75.4722 414.551L70.8652 417.184V428.372L75.5662 425.645Z",
    fill: "#CACACB"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0345 426.303C43.8807 426.585 44.8209 426.773 45.7611 426.961C48.6757 427.432 49.3338 430.534 49.3338 431.85V420.756C49.3338 419.44 48.6757 416.243 45.7611 415.867C44.8209 415.679 43.8807 415.491 43.0345 415.209C40.402 414.363 35.9831 416.337 34.3848 417.277V428.372C36.0771 427.432 40.496 425.363 43.0345 426.303Z",
    fill: "url(#paint75_linear)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1725 427.432C58.5486 427.243 59.0186 427.055 59.4887 426.961C60.4289 426.773 61.3691 426.585 62.2153 426.303C64.8479 425.363 69.2667 427.432 70.7711 428.372V417.277C69.1727 416.337 64.8479 414.363 62.2153 415.209C61.2751 415.491 60.4289 415.679 59.4887 415.867C59.0186 415.961 58.5486 416.149 58.1725 416.337C56.3861 417.371 56.01 419.722 55.916 420.85V431.944C56.01 430.816 56.3861 428.466 58.1725 427.432Z",
    fill: "url(#paint76_linear)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M33.35 409.568C34.8543 411.073 31.3756 413.611 29.7773 414.551L34.3842 417.278C35.9825 416.338 40.4014 414.363 43.034 415.21C43.8801 415.492 44.8204 415.68 45.7606 415.868C48.6752 416.338 49.3333 419.534 49.3333 420.851H55.9146C56.0087 419.722 56.3847 417.372 58.1711 416.338C58.5472 416.15 59.0173 415.962 59.4874 415.868C60.4276 415.68 61.3678 415.492 62.2139 415.21C64.8465 414.269 69.2654 416.338 70.7697 417.278L75.4706 414.551C73.8723 413.611 70.3936 411.073 71.8979 409.568C72.368 409.004 72.7441 408.534 73.0262 407.97C73.1202 407.688 73.4022 407.406 73.7783 407.218C75.5647 406.184 79.7015 405.902 81.5819 405.902V402.047C79.1374 402.141 73.7783 401.671 73.0262 399.978C72.7441 399.414 72.368 398.944 71.8979 398.38C70.3936 396.876 73.8723 394.337 75.4706 393.397L70.8637 390.671C69.2654 391.611 64.8465 393.585 62.2139 392.739C61.3678 392.457 60.4276 392.269 59.4874 392.081C56.5728 391.611 55.9146 388.414 55.9146 387.098H49.3333C49.3333 388.132 48.8632 390.577 47.0768 391.611C46.7007 391.799 46.2307 391.987 45.7606 392.081C44.8204 392.269 43.8801 392.457 43.034 392.739C40.0254 393.397 35.9825 391.611 34.4782 390.671L29.7773 393.397C31.3756 394.337 34.8543 396.876 33.35 398.38C32.8799 398.85 32.5038 399.414 32.2218 399.978C32.1277 400.26 31.8457 400.543 31.4696 400.731C29.6832 401.765 25.5464 402.047 23.666 402.047V405.902C25.9225 405.902 31.4696 406.278 32.2218 407.97C32.5978 408.534 32.9739 409.004 33.35 409.568ZM44.4443 399.226C49.0512 396.594 56.3847 396.594 60.9917 399.226C65.5046 401.859 65.5046 406.184 60.8976 408.816C56.2907 411.449 48.9572 411.449 44.3503 408.816C39.8373 406.09 39.9313 401.859 44.4443 399.226Z",
    fill: "#F1ECEC"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7773 414.551C31.3756 413.611 34.8543 411.073 33.35 409.568C32.8799 409.004 32.5038 408.534 32.2218 407.97C31.4696 406.278 25.9225 405.902 23.666 405.902V416.996C25.0763 416.996 27.7088 417.09 29.7773 417.654V414.551Z",
    fill: "#CACACB"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9134 431.945V420.757H49.332V431.945H55.9134Z",
    fill: "#CACACB"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7697 416.996V405.902C79.8893 405.902 75.7525 406.184 73.9661 407.218C73.59 407.406 73.3079 407.688 73.2139 407.97C72.9319 408.534 72.5558 409.004 72.0857 409.568C70.5814 411.073 74.0601 413.611 75.6584 414.551V417.748C77.5388 417.184 80.3594 416.996 81.7697 416.996Z",
    fill: "url(#paint77_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 113.862,
    y1: 273.262,
    x2: 113.862,
    y2: 329.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 29.8887,
    y1: 316.765,
    x2: 27.2324,
    y2: 307.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 13.6513,
    y1: 303.502,
    x2: 12.6192,
    y2: 301.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 29.8887,
    y1: 299.982,
    x2: 27.2324,
    y2: 290.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 13.6513,
    y1: 286.709,
    x2: 12.6192,
    y2: 284.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 6.15581,
    y1: 282.294,
    x2: 5.21473,
    y2: 280.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 29.8887,
    y1: 283.197,
    x2: 27.2296,
    y2: 274.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 13.6513,
    y1: 269.925,
    x2: 12.6192,
    y2: 268.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 29.8887,
    y1: 266.406,
    x2: 27.2324,
    y2: 257.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 13.6513,
    y1: 253.142,
    x2: 12.6192,
    y2: 251.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 486.007,
    y1: 182.268,
    x2: 486.007,
    y2: 252.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 253.085,
    y1: 316.777,
    x2: 253.085,
    y2: 387.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 369.571,
    y1: 249.527,
    x2: 369.571,
    y2: 320.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 387.946,
    y1: 105.426,
    x2: 387.946,
    y2: 70.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 119.913,
    y1: 230.386,
    x2: 130.858,
    y2: 230.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#3D3B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34318F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 156.72,
    y1: 210.065,
    x2: 156.72,
    y2: 227.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 146.818,
    y1: 211.549,
    x2: 117.045,
    y2: 211.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5618,
    stopColor: "#A7ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#D0D4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 134.767,
    y1: 206.069,
    x2: 145.163,
    y2: 206.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4783,
    stopColor: "#EAECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8037,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 132.992,
    y1: 193.989,
    x2: 153.43,
    y2: 193.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0348,
    stopColor: "#FED1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3073,
    stopColor: "#F5C398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6099,
    stopColor: "#F1BB8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB88B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 125.616,
    y1: 213.091,
    x2: 134.63,
    y2: 208.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4783,
    stopColor: "#EAECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8037,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 121.751,
    y1: 206.868,
    x2: 147.093,
    y2: 189.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3997,
    stopColor: "#FED1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#F9C99F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9538,
    stopColor: "#F1BB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB88B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 477.826,
    y1: 312.055,
    x2: 477.826,
    y2: 339.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 456.478,
    y1: 291.703,
    x2: 456.478,
    y2: 304.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 482.446,
    y1: 362.23,
    x2: 482.446,
    y2: 375.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 123.923,
    y1: 467.177,
    x2: 123.923,
    y2: 481.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 175.186,
    y1: 452.963,
    x2: 175.186,
    y2: 462.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 536.627,
    y1: 203.938,
    x2: 536.627,
    y2: 217.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 472.055,
    y1: 0,
    x2: 472.055,
    y2: 57.8907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 217.219,
    y1: 140.468,
    x2: 181.575,
    y2: 82.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 113.862,
    y1: 273.262,
    x2: 113.862,
    y2: 329.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 29.8887,
    y1: 316.765,
    x2: 27.2324,
    y2: 307.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 13.6513,
    y1: 303.502,
    x2: 12.6192,
    y2: 301.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 29.8887,
    y1: 299.982,
    x2: 27.2324,
    y2: 290.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 13.6513,
    y1: 286.709,
    x2: 12.6192,
    y2: 284.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 6.15581,
    y1: 282.294,
    x2: 5.21473,
    y2: 280.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 29.8887,
    y1: 283.197,
    x2: 27.2296,
    y2: 274.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 13.6513,
    y1: 269.925,
    x2: 12.6192,
    y2: 268.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 29.8887,
    y1: 266.406,
    x2: 27.2324,
    y2: 257.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 13.6513,
    y1: 253.142,
    x2: 12.6192,
    y2: 251.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 486.007,
    y1: 182.268,
    x2: 486.007,
    y2: 252.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 253.085,
    y1: 316.777,
    x2: 253.085,
    y2: 387.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 369.571,
    y1: 249.527,
    x2: 369.571,
    y2: 320.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 387.946,
    y1: 105.426,
    x2: 387.946,
    y2: 70.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 119.913,
    y1: 230.386,
    x2: 130.858,
    y2: 230.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#3D3B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34318F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 156.72,
    y1: 210.065,
    x2: 156.72,
    y2: 227.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 146.818,
    y1: 211.549,
    x2: 117.045,
    y2: 211.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5618,
    stopColor: "#A7ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#D0D4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 134.767,
    y1: 206.069,
    x2: 145.163,
    y2: 206.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4783,
    stopColor: "#EAECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8037,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 132.992,
    y1: 193.989,
    x2: 153.43,
    y2: 193.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0348,
    stopColor: "#FED1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3073,
    stopColor: "#F5C398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6099,
    stopColor: "#F1BB8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB88B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 125.616,
    y1: 213.091,
    x2: 134.63,
    y2: 208.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4783,
    stopColor: "#EAECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8037,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 121.751,
    y1: 206.868,
    x2: 147.093,
    y2: 189.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3997,
    stopColor: "#FED1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#F9C99F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9538,
    stopColor: "#F1BB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB88B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 477.826,
    y1: 312.055,
    x2: 477.826,
    y2: 339.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 456.478,
    y1: 291.703,
    x2: 456.478,
    y2: 304.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 482.446,
    y1: 362.23,
    x2: 482.446,
    y2: 375.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 123.923,
    y1: 467.177,
    x2: 123.923,
    y2: 481.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 175.186,
    y1: 452.963,
    x2: 175.186,
    y2: 462.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 536.627,
    y1: 203.938,
    x2: 536.627,
    y2: 217.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 472.055,
    y1: 0,
    x2: 472.055,
    y2: 57.8907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 217.219,
    y1: 140.468,
    x2: 181.575,
    y2: 82.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 329.555,
    y1: 191.749,
    x2: 329.555,
    y2: 281.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 363.447,
    y1: 316.495,
    x2: 363.447,
    y2: 322.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 377.508,
    y1: 308.251,
    x2: 360.489,
    y2: 305.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 354.316,
    y1: 311.53,
    x2: 365.386,
    y2: 311.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353434",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 340.138,
    y1: 319.782,
    x2: 351.208,
    y2: 319.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353434",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 358.145,
    y1: 252.866,
    x2: 367.296,
    y2: 252.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#8F8FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 341.588,
    y1: 265.301,
    x2: 365.405,
    y2: 265.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#8F8FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 331.921,
    y1: 254.087,
    x2: 351.623,
    y2: 254.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#8F8FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 310.994,
    y1: 349.468,
    x2: 310.994,
    y2: 414.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 309.427,
    y1: 371.827,
    x2: 321.574,
    y2: 407.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 327.994,
    y1: 450.866,
    x2: 339.041,
    y2: 450.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362E94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 389.181,
    y1: 449.06,
    x2: 389.181,
    y2: 484.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 339.167,
    y1: 407.935,
    x2: 339.167,
    y2: 413.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 326.659,
    y1: 411.359,
    x2: 326.659,
    y2: 419.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 351.202,
    y1: 418.127,
    x2: 350.724,
    y2: 416.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5836,
    stopColor: "#F3AC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 62.5912,
    y1: 398.286,
    x2: 62.5912,
    y2: 432.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 64.4714,
    y1: 404.574,
    x2: 42.943,
    y2: 430.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 49.3338,
    y1: 421.997,
    x2: 29.0759,
    y2: 438.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 70.7711,
    y1: 422.036,
    x2: 50.4493,
    y2: 438.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 81.7697,
    y1: 410.82,
    x2: 67.6639,
    y2: 421.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJwAAABaCAYAAABNCT/kAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScienceHero);
export default __webpack_public_path__ + "static/media/data_science_hero.064bdde332f1bba53f82824f915660ae.svg";
export { ForwardRef as ReactComponent };